import { Avatar, AvatarFallback, AvatarImage, Button, Button as Button$1, ButtonGroup, Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, Combobox, ComboboxContent, ComboboxEmpty, ComboboxInput, ComboboxItem, ComboboxList, Dialog, DialogContent, DialogDescription, DialogTitle, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger, Form, FormControl, FormField, FormItem, FormLabel, FormMessage, Input, InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot, Label, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, Separator, Sidebar, SidebarContent, SidebarFooter, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarProvider, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, Toaster, buttonVariants, toast } from "@repo/lib-web-ui-shadcn";
import { ROAD_OVERLAY_LOW_SPEED_COLOR, filterNulls, fmtDt } from "@repo/lib-common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx$1, { clsx } from "clsx";
import { faSpinner } from "@fortawesome/pro-duotone-svg-icons";
import { P as P$1, match } from "ts-pattern";
import { Fragment, jsxDEV } from "react/jsx-dev-runtime";
import { twMerge } from "tailwind-merge";
import React, { createContext, startTransition, useContext, useEffect, useId, useState } from "react";
import { AlertCircle, ArrowRightIcon, Check, CheckCircle, CheckIcon, ChevronDown, Clipboard, CreditCard, Loader2, LogOut, MoreHorizontal, PlusCircle, Settings, Unlink } from "lucide-react";
import { getFragmentData, graphql } from "@repo/lib-web-gql";
import { createColumnHelper, flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { cva } from "class-variance-authority";
import { stringProp } from "@repo/lib-web-common";
import { toast as toast$1 } from "sonner";
import { DevTool } from "@hookform/devtools";
import { arktypeResolver } from "@hookform/resolvers/arktype";
import { type } from "arktype";
import { useForm } from "react-hook-form";
export * from "@repo/lib-web-ui-shadcn";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
//#endregion
//#region src/design/atoms/spinner.tsx
var _jsxFileName$45 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/atoms/spinner.tsx";
function Spinner({ size, fullScreen }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: clsx$1(fullScreen && "w-screen h-screen flex justify-center items-center"),
		children: /* @__PURE__ */ jsxDEV(FontAwesomeIcon, {
			icon: faSpinner,
			spin: true,
			size: match(size).with("lg", () => "2x").with("sm", () => "sm").otherwise(() => void 0)
		}, void 0, false, {
			fileName: _jsxFileName$45,
			lineNumber: 21,
			columnNumber: 7
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$45,
		lineNumber: 16,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/atoms/typography.tsx
var _jsxFileName$44 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/atoms/typography.tsx";
function H1({ className, ...rest }) {
	return /* @__PURE__ */ jsxDEV("h1", {
		className: clsx("text-5xl font-extrabold mb-4", className),
		...rest
	}, void 0, false, {
		fileName: _jsxFileName$44,
		lineNumber: 7,
		columnNumber: 5
	}, this);
}
function H2({ className, ...rest }) {
	return /* @__PURE__ */ jsxDEV("h2", {
		className: clsx("text-4xl font-bold mt-3 mb-2", className),
		...rest
	}, void 0, false, {
		fileName: _jsxFileName$44,
		lineNumber: 16,
		columnNumber: 5
	}, this);
}
function H3({ className, ...rest }) {
	return /* @__PURE__ */ jsxDEV("h3", {
		className: clsx("text-3xl font-bold mt-2 mb-1", className),
		...rest
	}, void 0, false, {
		fileName: _jsxFileName$44,
		lineNumber: 25,
		columnNumber: 5
	}, this);
}
function H4({ className, ...rest }) {
	return /* @__PURE__ */ jsxDEV("h4", {
		className: clsx("text-2xl font-bold my-1", className),
		...rest
	}, void 0, false, {
		fileName: _jsxFileName$44,
		lineNumber: 34,
		columnNumber: 5
	}, this);
}
function H5({ className, ...rest }) {
	return /* @__PURE__ */ jsxDEV("h5", {
		className: clsx("text-xl font-bold", className),
		...rest
	}, void 0, false, {
		fileName: _jsxFileName$44,
		lineNumber: 42,
		columnNumber: 10
	}, this);
}
function H6({ className, ...rest }) {
	return /* @__PURE__ */ jsxDEV("h6", {
		className: clsx("text-lg font-bold", className),
		...rest
	}, void 0, false, {
		fileName: _jsxFileName$44,
		lineNumber: 49,
		columnNumber: 10
	}, this);
}
function P({ className, ...rest }) {
	return /* @__PURE__ */ jsxDEV("p", {
		className: clsx("text-lg", className),
		...rest
	}, void 0, false, {
		fileName: _jsxFileName$44,
		lineNumber: 56,
		columnNumber: 10
	}, this);
}
function Caption({ className, ...rest }) {
	return /* @__PURE__ */ jsxDEV("p", {
		className: clsx("text-sm italic opacity-75", className),
		...rest
	}, void 0, false, {
		fileName: _jsxFileName$44,
		lineNumber: 64,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/lib/utils.ts
function cn(...inputs) {
	return twMerge(clsx(inputs));
}
//#endregion
//#region src/design/atoms/card-container.tsx
var _jsxFileName$43 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/atoms/card-container.tsx";
function CardContainer({ children, className }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("rounded-lg border bg-card p-6 shadow-sm", className),
		children
	}, void 0, false, {
		fileName: _jsxFileName$43,
		lineNumber: 9,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/atoms/container.tsx
var _jsxFileName$42 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/atoms/container.tsx";
function Container({ size, debugMode, className, children }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: clsx$1("Container overflow-auto mx-auto", className, debugMode && "border border-primary bg-secondary min-h-10", match(size).with("sm", () => "max-w-2xl px-2 lg:px-4").with("md", () => "max-w-4xl px-2 lg:px-4").with("lg", P$1.nullish, () => "max-w-7xl sm:px-6 lg:px-8").with("xl", () => "max-w-[96rem] sm:px-6 lg:px-8").exhaustive()),
		children: [children, debugMode && /* @__PURE__ */ jsxDEV("div", {
			className: "bg-gradient-to-br from-red-300 to-blue-500 h-[200vh] w-[200vw]",
			children: "hi"
		}, void 0, false, {
			fileName: _jsxFileName$42,
			lineNumber: 34,
			columnNumber: 9
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$42,
		lineNumber: 19,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/atoms/page-header.tsx
var _jsxFileName$41 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/atoms/page-header.tsx";
function PageHeader({ title, className }) {
	return /* @__PURE__ */ jsxDEV(H1, {
		className: cn("mb-10", className),
		children: title
	}, void 0, false, {
		fileName: _jsxFileName$41,
		lineNumber: 11,
		columnNumber: 10
	}, this);
}
//#endregion
//#region src/design/molecules/input-otp.tsx
var _jsxFileName$40 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/input-otp.tsx";
function InputOtp(props) {
	return /* @__PURE__ */ jsxDEV(InputOTP, {
		...props,
		maxLength: 6,
		children: [
			/* @__PURE__ */ jsxDEV(InputOTPGroup, { children: [
				/* @__PURE__ */ jsxDEV(InputOTPSlot, { index: 0 }, void 0, false, {
					fileName: _jsxFileName$40,
					lineNumber: 15,
					columnNumber: 9
				}, this),
				/* @__PURE__ */ jsxDEV(InputOTPSlot, { index: 1 }, void 0, false, {
					fileName: _jsxFileName$40,
					lineNumber: 16,
					columnNumber: 9
				}, this),
				/* @__PURE__ */ jsxDEV(InputOTPSlot, { index: 2 }, void 0, false, {
					fileName: _jsxFileName$40,
					lineNumber: 17,
					columnNumber: 9
				}, this)
			] }, void 0, true, {
				fileName: _jsxFileName$40,
				lineNumber: 14,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV(InputOTPSeparator, {}, void 0, false, {
				fileName: _jsxFileName$40,
				lineNumber: 19,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV(InputOTPGroup, { children: [
				/* @__PURE__ */ jsxDEV(InputOTPSlot, { index: 3 }, void 0, false, {
					fileName: _jsxFileName$40,
					lineNumber: 21,
					columnNumber: 9
				}, this),
				/* @__PURE__ */ jsxDEV(InputOTPSlot, { index: 4 }, void 0, false, {
					fileName: _jsxFileName$40,
					lineNumber: 22,
					columnNumber: 9
				}, this),
				/* @__PURE__ */ jsxDEV(InputOTPSlot, { index: 5 }, void 0, false, {
					fileName: _jsxFileName$40,
					lineNumber: 23,
					columnNumber: 9
				}, this)
			] }, void 0, true, {
				fileName: _jsxFileName$40,
				lineNumber: 20,
				columnNumber: 7
			}, this)
		]
	}, void 0, true, {
		fileName: _jsxFileName$40,
		lineNumber: 13,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/molecules/input-with-button.tsx
var _jsxFileName$39 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/input-with-button.tsx";
function InputWithButton({ label, inputProps, startAdornment, endAdornment, buttonProps }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: "flex w-full max-w-sm items-center space-x-2",
		children: [
			label && /* @__PURE__ */ jsxDEV(Label, {
				htmlFor: inputProps.id,
				children: label
			}, void 0, false, {
				fileName: _jsxFileName$39,
				lineNumber: 21,
				columnNumber: 17
			}, this),
			startAdornment && /* @__PURE__ */ jsxDEV("span", {
				className: "px-3 text-sm text-muted-foreground",
				children: startAdornment
			}, void 0, false, {
				fileName: _jsxFileName$39,
				lineNumber: 23,
				columnNumber: 9
			}, this),
			/* @__PURE__ */ jsxDEV(Input, { ...inputProps }, void 0, false, {
				fileName: _jsxFileName$39,
				lineNumber: 28,
				columnNumber: 7
			}, this),
			endAdornment && /* @__PURE__ */ jsxDEV("span", {
				className: "px-3 text-sm text-muted-foreground",
				children: endAdornment
			}, void 0, false, {
				fileName: _jsxFileName$39,
				lineNumber: 30,
				columnNumber: 9
			}, this),
			buttonProps && /* @__PURE__ */ jsxDEV(Button, { ...buttonProps }, void 0, false, {
				fileName: _jsxFileName$39,
				lineNumber: 35,
				columnNumber: 23
			}, this)
		]
	}, void 0, true, {
		fileName: _jsxFileName$39,
		lineNumber: 20,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/molecules/json-display.tsx
var _jsxFileName$38 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/json-display.tsx";
function JsonDisplay({ data }) {
	const string = React.useMemo(() => {
		try {
			return JSON.stringify(data, null, 2);
		} catch {
			return "--Error stringifying JSON--";
		}
	}, [data]);
	return /* @__PURE__ */ jsxDEV("div", {
		className: "relative",
		children: [/* @__PURE__ */ jsxDEV("div", {
			className: "absolute right-2 top-2",
			children: /* @__PURE__ */ jsxDEV(Button, {
				onClick: React.useCallback(() => {
					navigator.clipboard.writeText(string);
					toast("Copied to clipboard");
				}, [string]),
				children: [/* @__PURE__ */ jsxDEV(Clipboard, {}, void 0, false, {
					fileName: _jsxFileName$38,
					lineNumber: 23,
					columnNumber: 11
				}, this), "copy"]
			}, void 0, true, {
				fileName: _jsxFileName$38,
				lineNumber: 22,
				columnNumber: 9
			}, this)
		}, void 0, false, {
			fileName: _jsxFileName$38,
			lineNumber: 21,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV("pre", {
			className: "max-h-96 w-full overflow-auto rounded-md bg-black/10 p-4 text-xs",
			children: string
		}, void 0, false, {
			fileName: _jsxFileName$38,
			lineNumber: 27,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$38,
		lineNumber: 20,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/molecules/pill-button-group.tsx
var _jsxFileName$37 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/pill-button-group.tsx";
function PillButtonGroup({ items, className, buttonClassName, variant = "secondary", size = "default" }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("flex flex-wrap gap-2", className),
		children: items.map((item) => /* @__PURE__ */ jsxDEV(Button, {
			type: "button",
			variant,
			size,
			disabled: item.disabled,
			className: cn("rounded-full", buttonClassName, item.className),
			onClick: item.onClick,
			children: item.label
		}, item.id, false, {
			fileName: _jsxFileName$37,
			lineNumber: 31,
			columnNumber: 9
		}, this))
	}, void 0, false, {
		fileName: _jsxFileName$37,
		lineNumber: 29,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/molecules/spinner-button.tsx
var _jsxFileName$36 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/spinner-button.tsx";
function SpinnerButton({ className, children, disabled, forceLoading, onClickAsync, ...props }) {
	const [loadingInner, setLoading] = React.useState(false);
	const loading = forceLoading || loadingInner;
	const onClickWrapper = async () => {
		if (disabled || loading) return;
		setLoading(true);
		try {
			await onClickAsync?.();
		} finally {
			setLoading(false);
		}
	};
	return /* @__PURE__ */ jsxDEV(Button, {
		...props,
		className: clsx$1(className),
		disabled: disabled || loading,
		onClick: onClickWrapper,
		children: [/* @__PURE__ */ jsxDEV("div", {
			className: clsx$1("whitespace-nowrap flex-row flex gap-0.5 justify-center items-center", loading ? "opacity-0" : ""),
			children
		}, void 0, false, {
			fileName: _jsxFileName$36,
			lineNumber: 39,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV("div", {
			className: loading ? "absolute mx-auto" : "hidden",
			children: /* @__PURE__ */ jsxDEV(Spinner, {}, void 0, false, {
				fileName: _jsxFileName$36,
				lineNumber: 48,
				columnNumber: 9
			}, this)
		}, void 0, false, {
			fileName: _jsxFileName$36,
			lineNumber: 47,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$36,
		lineNumber: 33,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/molecules/card.tsx
var card_exports = /* @__PURE__ */ __exportAll({});
import * as import__repo_lib_web_ui_shadcn from "@repo/lib-web-ui-shadcn";
__reExport(card_exports, import__repo_lib_web_ui_shadcn);
//#endregion
//#region src/design/molecules/crossfade-image-stack.tsx
var _jsxFileName$35 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/crossfade-image-stack.tsx";
function CrossfadeImageStack({ slides, durationSeconds = 13.5, className, imageClassName }) {
	const cycleDuration = Math.max(durationSeconds, .1);
	const delayStep = slides.length > 0 ? cycleDuration / slides.length : 0;
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("absolute inset-0", className),
		children: slides.map((slide, index) => /* @__PURE__ */ jsxDEV("img", {
			src: slide.src,
			alt: slide.alt,
			loading: slide.loading,
			decoding: slide.decoding,
			className: cn("absolute inset-0 h-full w-full object-cover opacity-0 animate-hero-crossfade", imageClassName, slide.className),
			style: {
				animationDelay: `${delayStep * index}s`,
				animationDuration: `${cycleDuration}s`
			}
		}, `${slide.src}-${index}`, false, {
			fileName: _jsxFileName$35,
			lineNumber: 31,
			columnNumber: 9
		}, this))
	}, void 0, false, {
		fileName: _jsxFileName$35,
		lineNumber: 29,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/app-sidebar.tsx
var _jsxFileName$34 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/app-sidebar.tsx";
function AppSidebarItem({ item: currentSidebarItem }) {
	return match(currentSidebarItem).with({ kind: "link" }, (item) => /* @__PURE__ */ jsxDEV(SidebarMenuButton, { render: item.component }, void 0, false, {
		fileName: _jsxFileName$34,
		lineNumber: 60,
		columnNumber: 7
	}, this)).with({ kind: "group" }, (item) => /* @__PURE__ */ jsxDEV(SidebarGroup, { children: [/* @__PURE__ */ jsxDEV(SidebarGroupLabel, { children: item.label }, void 0, false, {
		fileName: _jsxFileName$34,
		lineNumber: 64,
		columnNumber: 9
	}, this), /* @__PURE__ */ jsxDEV(SidebarGroupContent, { children: /* @__PURE__ */ jsxDEV(SidebarMenu, { children: item.items.map((subItem, idx) => /* @__PURE__ */ jsxDEV(AppSidebarItem, { item: subItem }, idx, false, {
		fileName: _jsxFileName$34,
		lineNumber: 68,
		columnNumber: 15
	}, this)) }, void 0, false, {
		fileName: _jsxFileName$34,
		lineNumber: 66,
		columnNumber: 11
	}, this) }, void 0, false, {
		fileName: _jsxFileName$34,
		lineNumber: 65,
		columnNumber: 9
	}, this)] }, void 0, true, {
		fileName: _jsxFileName$34,
		lineNumber: 63,
		columnNumber: 7
	}, this)).exhaustive();
}
function AppSidebar({ onSignOut, items, orgs }) {
	return /* @__PURE__ */ jsxDEV(Sidebar, { children: [
		orgs.active && /* @__PURE__ */ jsxDEV(SidebarHeader, { children: /* @__PURE__ */ jsxDEV(SidebarMenu, { children: /* @__PURE__ */ jsxDEV(SidebarMenuItem, { children: /* @__PURE__ */ jsxDEV(DropdownMenu, { children: [/* @__PURE__ */ jsxDEV(DropdownMenuTrigger, { render: /* @__PURE__ */ jsxDEV(SidebarMenuButton, {
			className: "SMB1 data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground",
			size: "lg",
			children: [/* @__PURE__ */ jsxDEV("div", {
				className: "grid flex-1 text-left text-sm leading-tight",
				children: [/* @__PURE__ */ jsxDEV("span", {
					className: "truncate text-xs",
					children: "Organization"
				}, void 0, false, {
					fileName: _jsxFileName$34,
					lineNumber: 96,
					columnNumber: 25
				}, this), /* @__PURE__ */ jsxDEV("span", {
					className: "truncate font-medium",
					children: orgs.active.name
				}, void 0, false, {
					fileName: _jsxFileName$34,
					lineNumber: 97,
					columnNumber: 25
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$34,
				lineNumber: 95,
				columnNumber: 23
			}, this), /* @__PURE__ */ jsxDEV(ChevronDown, { className: "ml-auto" }, void 0, false, {
				fileName: _jsxFileName$34,
				lineNumber: 101,
				columnNumber: 23
			}, this)]
		}, void 0, true, {
			fileName: _jsxFileName$34,
			lineNumber: 90,
			columnNumber: 21
		}, this) }, void 0, false, {
			fileName: _jsxFileName$34,
			lineNumber: 88,
			columnNumber: 17
		}, this), /* @__PURE__ */ jsxDEV(DropdownMenuContent, {
			align: "start",
			side: "bottom",
			style: { minWidth: "var(--radix-popper-anchor-width)" },
			children: [
				/* @__PURE__ */ jsxDEV(DropdownMenuItem, { children: [/* @__PURE__ */ jsxDEV("span", { children: orgs.active.name }, void 0, false, {
					fileName: _jsxFileName$34,
					lineNumber: 111,
					columnNumber: 21
				}, this), /* @__PURE__ */ jsxDEV(Check, { className: "ml-auto h-4 w-4" }, void 0, false, {
					fileName: _jsxFileName$34,
					lineNumber: 112,
					columnNumber: 21
				}, this)] }, void 0, true, {
					fileName: _jsxFileName$34,
					lineNumber: 110,
					columnNumber: 19
				}, this),
				/* @__PURE__ */ jsxDEV(DropdownMenuSeparator, {}, void 0, false, {
					fileName: _jsxFileName$34,
					lineNumber: 114,
					columnNumber: 19
				}, this),
				orgs.others.map((org) => /* @__PURE__ */ jsxDEV(DropdownMenuItem, {
					onSelect: () => orgs.onChange(org.id),
					children: /* @__PURE__ */ jsxDEV("span", { children: org.name }, void 0, false, {
						fileName: _jsxFileName$34,
						lineNumber: 120,
						columnNumber: 23
					}, this)
				}, org.id, false, {
					fileName: _jsxFileName$34,
					lineNumber: 116,
					columnNumber: 21
				}, this)),
				orgs.others.length > 0 && /* @__PURE__ */ jsxDEV(DropdownMenuSeparator, {}, void 0, false, {
					fileName: _jsxFileName$34,
					lineNumber: 123,
					columnNumber: 46
				}, this),
				/* @__PURE__ */ jsxDEV(DropdownMenuItem, { children: "Create New Organization" }, void 0, false, {
					fileName: _jsxFileName$34,
					lineNumber: 124,
					columnNumber: 19
				}, this)
			]
		}, void 0, true, {
			fileName: _jsxFileName$34,
			lineNumber: 105,
			columnNumber: 17
		}, this)] }, void 0, true, {
			fileName: _jsxFileName$34,
			lineNumber: 87,
			columnNumber: 15
		}, this) }, void 0, false, {
			fileName: _jsxFileName$34,
			lineNumber: 86,
			columnNumber: 13
		}, this) }, void 0, false, {
			fileName: _jsxFileName$34,
			lineNumber: 85,
			columnNumber: 11
		}, this) }, void 0, false, {
			fileName: _jsxFileName$34,
			lineNumber: 84,
			columnNumber: 9
		}, this),
		/* @__PURE__ */ jsxDEV(SidebarContent, { children: items.map((item, idx) => /* @__PURE__ */ jsxDEV(AppSidebarItem, { item }, idx, false, {
			fileName: _jsxFileName$34,
			lineNumber: 133,
			columnNumber: 11
		}, this)) }, void 0, false, {
			fileName: _jsxFileName$34,
			lineNumber: 131,
			columnNumber: 7
		}, this),
		/* @__PURE__ */ jsxDEV(SidebarFooter, { children: /* @__PURE__ */ jsxDEV(SidebarMenu, { children: /* @__PURE__ */ jsxDEV(SidebarMenuButton, {
			onClick: onSignOut,
			className: "capitalize",
			children: [/* @__PURE__ */ jsxDEV(LogOut, {}, void 0, false, {
				fileName: _jsxFileName$34,
				lineNumber: 140,
				columnNumber: 13
			}, this), "logout"]
		}, void 0, true, {
			fileName: _jsxFileName$34,
			lineNumber: 138,
			columnNumber: 11
		}, this) }, void 0, false, {
			fileName: _jsxFileName$34,
			lineNumber: 137,
			columnNumber: 9
		}, this) }, void 0, false, {
			fileName: _jsxFileName$34,
			lineNumber: 136,
			columnNumber: 7
		}, this)
	] }, void 0, true, {
		fileName: _jsxFileName$34,
		lineNumber: 82,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/full-page-card.tsx
var _jsxFileName$33 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/full-page-card.tsx";
function FullPageCard({ header, className, cardClassName, children, footer }) {
	return /* @__PURE__ */ jsxDEV("main", {
		className: clsx$1("flex min-h-screen flex-col items-center justify-center p-24 bg-gradient-to-b from-blue-100 to-white", className),
		children: /* @__PURE__ */ jsxDEV(card_exports.Card, {
			className: clsx$1("w-[350px]", cardClassName),
			children: [
				match(header).with({ headerComponent: P$1.select() }, (c) => c).with({
					title: P$1.string,
					description: P$1.string
				}, ({ title, description }) => /* @__PURE__ */ jsxDEV(card_exports.CardHeader, { children: [/* @__PURE__ */ jsxDEV(card_exports.CardTitle, {
					className: "text-2xl font-bold text-center",
					children: title
				}, void 0, false, {
					fileName: _jsxFileName$33,
					lineNumber: 47,
					columnNumber: 17
				}, this), /* @__PURE__ */ jsxDEV(card_exports.CardDescription, {
					className: "text-center",
					children: description
				}, void 0, false, {
					fileName: _jsxFileName$33,
					lineNumber: 50,
					columnNumber: 17
				}, this)] }, void 0, true, {
					fileName: _jsxFileName$33,
					lineNumber: 46,
					columnNumber: 15
				}, this)).with(P$1.nullish, () => null).exhaustive(),
				/* @__PURE__ */ jsxDEV(card_exports.CardContent, { children }, void 0, false, {
					fileName: _jsxFileName$33,
					lineNumber: 58,
					columnNumber: 9
				}, this),
				/* @__PURE__ */ jsxDEV(card_exports.CardFooter, { children: footer }, void 0, false, {
					fileName: _jsxFileName$33,
					lineNumber: 59,
					columnNumber: 9
				}, this)
			]
		}, void 0, true, {
			fileName: _jsxFileName$33,
			lineNumber: 40,
			columnNumber: 7
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$33,
		lineNumber: 34,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/data-table.tsx
var _jsxFileName$32 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/data-table.tsx";
function DataTable({ columns, data }) {
	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel()
	});
	return /* @__PURE__ */ jsxDEV("div", {
		className: "rounded-md border",
		children: /* @__PURE__ */ jsxDEV(Table, { children: [/* @__PURE__ */ jsxDEV(TableHeader, { children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsxDEV(TableRow, { children: headerGroup.headers.map((header) => {
			return /* @__PURE__ */ jsxDEV(TableHead, { children: header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext()) }, header.id, false, {
				fileName: _jsxFileName$32,
				lineNumber: 37,
				columnNumber: 19
			}, this);
		}) }, headerGroup.id, false, {
			fileName: _jsxFileName$32,
			lineNumber: 34,
			columnNumber: 13
		}, this)) }, void 0, false, {
			fileName: _jsxFileName$32,
			lineNumber: 32,
			columnNumber: 9
		}, this), /* @__PURE__ */ jsxDEV(TableBody, { children: table.getRowModel().rows?.length ? table.getRowModel().rows.map((row) => /* @__PURE__ */ jsxDEV(TableRow, {
			"data-state": row.getIsSelected() && "selected",
			children: row.getVisibleCells().map((cell) => /* @__PURE__ */ jsxDEV(TableCell, { children: flexRender(cell.column.columnDef.cell, cell.getContext()) }, cell.id, false, {
				fileName: _jsxFileName$32,
				lineNumber: 58,
				columnNumber: 19
			}, this))
		}, row.id, false, {
			fileName: _jsxFileName$32,
			lineNumber: 53,
			columnNumber: 15
		}, this)) : /* @__PURE__ */ jsxDEV(TableRow, { children: /* @__PURE__ */ jsxDEV(TableCell, {
			colSpan: columns.length,
			className: "h-24 text-center",
			children: "No results."
		}, void 0, false, {
			fileName: _jsxFileName$32,
			lineNumber: 66,
			columnNumber: 15
		}, this) }, void 0, false, {
			fileName: _jsxFileName$32,
			lineNumber: 65,
			columnNumber: 13
		}, this) }, void 0, false, {
			fileName: _jsxFileName$32,
			lineNumber: 50,
			columnNumber: 9
		}, this)] }, void 0, true, {
			fileName: _jsxFileName$32,
			lineNumber: 31,
			columnNumber: 7
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$32,
		lineNumber: 30,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/atoms/role-badge.tsx
var _jsxFileName$31 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/atoms/role-badge.tsx";
var badgeVariants = cva("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
	variants: { variant: {
		owner: "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300",
		admin: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300",
		staff: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300",
		customer: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300"
	} },
	defaultVariants: { variant: "admin" }
});
function RoleBadge({ className, role, ...props }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn(badgeVariants({ variant: role }), className),
		...props,
		children: role.charAt(0).toUpperCase() + role.slice(1)
	}, void 0, false, {
		fileName: _jsxFileName$31,
		lineNumber: 38,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/organization/my-pending-invites.tsx
var _jsxFileName$30 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/organization/my-pending-invites.tsx";
var MyPendingInviteListFragment = graphql(`
  fragment MyPendingInviteListFragment on OrganizationInvitationsConnection {
    edges {
      node {
        id
        organization {
          id
          name
        }
        email
        role
        status
        createdAt
      }
    }
  }
`);
var columnHelper$2 = createColumnHelper();
function useInvitationColumns$1(actions) {
	return React.useMemo(() => [
		columnHelper$2.accessor("createdAt", {
			header: "Sent",
			cell: (info) => fmtDt(info.getValue())
		}),
		columnHelper$2.accessor("email", {
			header: "Email",
			cell: (info) => info.getValue()
		}),
		columnHelper$2.accessor("role", {
			header: "Role",
			cell: ({ row }) => /* @__PURE__ */ jsxDEV(RoleBadge, { role: row.original.role }, void 0, false, {
				fileName: _jsxFileName$30,
				lineNumber: 62,
				columnNumber: 28
			}, this)
		}),
		columnHelper$2.accessor("status", {
			header: "Status",
			cell: (props) => match(props.row.original.status).with("pending", () => "Pending").with("accepted", () => "Accepted").with("expired", () => "Expired").exhaustive()
		}),
		columnHelper$2.display({
			id: "actions",
			header: "Actions",
			cell: (info) => /* @__PURE__ */ jsxDEV("div", {
				className: "flex gap-2",
				children: [/* @__PURE__ */ jsxDEV(SpinnerButton, {
					size: "sm",
					disabled: info.row.original.status !== "pending",
					className: info.row.original.status === "pending" ? "" : "!opacity-0",
					onClickAsync: () => actions.accept(info.row.original.id).then((error) => error ? toast$1.error(stringProp(error, "message") ?? "Unknown error") : toast$1("Accepted")),
					children: "Accept"
				}, void 0, false, {
					fileName: _jsxFileName$30,
					lineNumber: 79,
					columnNumber: 13
				}, this), /* @__PURE__ */ jsxDEV(SpinnerButton, {
					variant: "destructive",
					size: "sm",
					disabled: info.row.original.status !== "pending",
					className: info.row.original.status === "pending" ? "" : "!opacity-0",
					onClickAsync: () => actions.decline(info.row.original.id).then(() => toast$1("Declined", { description: "That invitation" })),
					children: "Decline"
				}, void 0, false, {
					fileName: _jsxFileName$30,
					lineNumber: 99,
					columnNumber: 13
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$30,
				lineNumber: 78,
				columnNumber: 11
			}, this)
		})
	], [actions]);
}
function MyPendingInviteList({ dbFragment, actions }) {
	return /* @__PURE__ */ jsxDEV(DataTable, {
		columns: useInvitationColumns$1(actions),
		data: getFragmentData(MyPendingInviteListFragment, dbFragment)?.edges.map((e) => e.node) ?? []
	}, void 0, false, {
		fileName: _jsxFileName$30,
		lineNumber: 151,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/organization/create-new-organization-form.tsx
var _jsxFileName$29 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/organization/create-new-organization-form.tsx";
function CreateNewOrganizationForm({ onCreate, name, setName }) {
	return /* @__PURE__ */ jsxDEV(Card, {
		className: "mb-8",
		children: [
			/* @__PURE__ */ jsxDEV(CardHeader, {
				className: "pb-3",
				children: [/* @__PURE__ */ jsxDEV(CardTitle, {
					className: "text-xl",
					children: "Create a new organization"
				}, void 0, false, {
					fileName: _jsxFileName$29,
					lineNumber: 26,
					columnNumber: 9
				}, this), /* @__PURE__ */ jsxDEV(CardDescription, { children: "Start fresh with your own organization" }, void 0, false, {
					fileName: _jsxFileName$29,
					lineNumber: 27,
					columnNumber: 9
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$29,
				lineNumber: 25,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV(CardContent, { children: /* @__PURE__ */ jsxDEV("div", {
				className: "grid gap-4",
				children: /* @__PURE__ */ jsxDEV("div", {
					className: "grid gap-2",
					children: [/* @__PURE__ */ jsxDEV("label", {
						htmlFor: "organization-name",
						className: "text-sm font-medium",
						children: "Organization Name"
					}, void 0, false, {
						fileName: _jsxFileName$29,
						lineNumber: 34,
						columnNumber: 13
					}, this), /* @__PURE__ */ jsxDEV(Input, {
						id: "organization-name",
						value: name,
						onChange: (e) => setName(e.target.value),
						placeholder: "Enter organization name"
					}, void 0, false, {
						fileName: _jsxFileName$29,
						lineNumber: 37,
						columnNumber: 13
					}, this)]
				}, void 0, true, {
					fileName: _jsxFileName$29,
					lineNumber: 33,
					columnNumber: 11
				}, this)
			}, void 0, false, {
				fileName: _jsxFileName$29,
				lineNumber: 32,
				columnNumber: 9
			}, this) }, void 0, false, {
				fileName: _jsxFileName$29,
				lineNumber: 31,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV(CardFooter, { children: /* @__PURE__ */ jsxDEV(SpinnerButton, {
				disabled: !name || name?.length < 0,
				onClickAsync: onCreate,
				className: "ml-auto",
				children: [/* @__PURE__ */ jsxDEV(PlusCircle, { className: "mr-2 h-4 w-4" }, void 0, false, {
					fileName: _jsxFileName$29,
					lineNumber: 52,
					columnNumber: 11
				}, this), "Create Organization"]
			}, void 0, true, {
				fileName: _jsxFileName$29,
				lineNumber: 47,
				columnNumber: 9
			}, this) }, void 0, false, {
				fileName: _jsxFileName$29,
				lineNumber: 46,
				columnNumber: 7
			}, this)
		]
	}, void 0, true, {
		fileName: _jsxFileName$29,
		lineNumber: 24,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/subscriptions/pricing-card.tsx
var _jsxFileName$28 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/subscriptions/pricing-card.tsx";
var PricingCardFragment = graphql(`
  fragment PricingCardFragment on ApiSubscriptionPlan {
    __typename
    description
    name
    prices {
      id
      amountCents
      currency
      stripePriceId
      recurring {
        interval
        intervalCount
        trialPeriodDays
        billingScheme {
          __typename
          ... on ApiSubscriptionPlanPriceBillingSchemePerUnit {
            usageType
          }
          ... on ApiSubscriptionPlanPriceBillingSchemeTiered {
            tiersMode
            tiers {
              flatAmountCents
              unitAmountCents
              upTo
            }
          }
        }
      }
    }
  }
`);
function formatPrice(cents) {
	return (cents / 100).toFixed(2);
}
function formatInterval(interval) {
	return interval.toLowerCase();
}
function PricingCard({ dbFragment, highlight, interval, onSubscribeClick, featured = false }) {
	const plan = getFragmentData(PricingCardFragment, dbFragment);
	console.log(`🚀 - pricing-card.tsx:59 - PricingCard - plan:`, plan);
	const price = plan.prices.filter((p) => p.recurring?.interval === interval)[0];
	if (!price) return null;
	const billingScheme = price?.recurring?.billingScheme;
	const isTiered = billingScheme?.__typename === "ApiSubscriptionPlanPriceBillingSchemeTiered";
	return /* @__PURE__ */ jsxDEV(card_exports.Card, {
		className: cn(`relative flex flex-col overflow-hidden border-2 transition-all hover:border-accent/50`, featured ? "border-border bg-card" : "border-border bg-card", !highlight ? "opacity-60" : ""),
		children: [featured && /* @__PURE__ */ jsxDEV("div", {
			className: "absolute right-4 top-4",
			children: /* @__PURE__ */ jsxDEV("span", {
				className: "inline-flex items-center rounded-full bg-accent px-3 py-1 text-xs font-medium text-accent-foreground",
				children: "Recommended"
			}, void 0, false, {
				fileName: _jsxFileName$28,
				lineNumber: 87,
				columnNumber: 11
			}, this)
		}, void 0, false, {
			fileName: _jsxFileName$28,
			lineNumber: 86,
			columnNumber: 9
		}, this), /* @__PURE__ */ jsxDEV("div", {
			className: "flex h-full flex-col gap-6 px-6",
			children: [
				/* @__PURE__ */ jsxDEV("div", { children: [
					/* @__PURE__ */ jsxDEV("h3", {
						className: `mb-2 text-2xl font-bold ${highlight ? "text-foreground" : "text-muted-foreground"}`,
						children: plan.name
					}, void 0, false, {
						fileName: _jsxFileName$28,
						lineNumber: 95,
						columnNumber: 11
					}, this),
					/* @__PURE__ */ jsxDEV("div", {
						className: "mb-4 flex items-baseline gap-1",
						children: [/* @__PURE__ */ jsxDEV("span", {
							className: `text-4xl font-bold ${highlight ? "text-foreground" : "text-muted-foreground"}`,
							children: ["$", formatPrice(price?.amountCents || 0)]
						}, void 0, true, {
							fileName: _jsxFileName$28,
							lineNumber: 101,
							columnNumber: 13
						}, this), /* @__PURE__ */ jsxDEV("span", {
							className: "text-muted-foreground",
							children: ["/", formatInterval(price?.recurring?.interval || "month")]
						}, void 0, true, {
							fileName: _jsxFileName$28,
							lineNumber: 106,
							columnNumber: 13
						}, this)]
					}, void 0, true, {
						fileName: _jsxFileName$28,
						lineNumber: 100,
						columnNumber: 11
					}, this),
					plan.description && /* @__PURE__ */ jsxDEV("p", {
						className: "text-sm text-muted-foreground",
						children: plan.description
					}, void 0, false, {
						fileName: _jsxFileName$28,
						lineNumber: 111,
						columnNumber: 13
					}, this)
				] }, void 0, true, {
					fileName: _jsxFileName$28,
					lineNumber: 94,
					columnNumber: 9
				}, this),
				/* @__PURE__ */ jsxDEV("div", {
					className: "flex-1 space-y-4",
					children: isTiered && billingScheme.__typename === "ApiSubscriptionPlanPriceBillingSchemeTiered" ? /* @__PURE__ */ jsxDEV(Fragment, { children: /* @__PURE__ */ jsxDEV("div", {
						className: "space-y-2",
						children: [/* @__PURE__ */ jsxDEV("div", {
							className: "flex items-start gap-2",
							children: [/* @__PURE__ */ jsxDEV(Check, { className: `mt-0.5 h-5 w-5 shrink-0 ${highlight ? "text-foreground" : "text-muted-foreground"}` }, void 0, false, {
								fileName: _jsxFileName$28,
								lineNumber: 122,
								columnNumber: 19
							}, this), /* @__PURE__ */ jsxDEV("span", {
								className: `text-sm ${highlight ? "text-foreground" : "text-muted-foreground"}`,
								children: [
									"Tiered pricing with ",
									billingScheme.tiersMode.toLowerCase(),
									" ",
									"billing"
								]
							}, void 0, true, {
								fileName: _jsxFileName$28,
								lineNumber: 125,
								columnNumber: 19
							}, this)]
						}, void 0, true, {
							fileName: _jsxFileName$28,
							lineNumber: 121,
							columnNumber: 17
						}, this), billingScheme.tiers.map((tier, idx) => /* @__PURE__ */ jsxDEV("div", {
							className: "flex items-start gap-2 pl-7",
							children: /* @__PURE__ */ jsxDEV("span", {
								className: "text-sm text-muted-foreground",
								children: [tier.flatAmountCents ? `$${formatPrice(tier.flatAmountCents)} flat fee` : `$${formatPrice(tier.unitAmountCents || 0)} per unit`, tier.upTo ? ` up to ${tier.upTo} units` : " (unlimited)"]
							}, void 0, true, {
								fileName: _jsxFileName$28,
								lineNumber: 134,
								columnNumber: 21
							}, this)
						}, idx, false, {
							fileName: _jsxFileName$28,
							lineNumber: 133,
							columnNumber: 19
						}, this))]
					}, void 0, true, {
						fileName: _jsxFileName$28,
						lineNumber: 120,
						columnNumber: 15
					}, this) }, void 0, false) : /* @__PURE__ */ jsxDEV(Fragment, { children: [
						/* @__PURE__ */ jsxDEV("div", {
							className: "flex items-start gap-2",
							children: [/* @__PURE__ */ jsxDEV(Check, { className: `mt-0.5 h-5 w-5 shrink-0 ${highlight ? "text-foreground" : "text-muted-foreground"}` }, void 0, false, {
								fileName: _jsxFileName$28,
								lineNumber: 147,
								columnNumber: 17
							}, this), /* @__PURE__ */ jsxDEV("span", {
								className: `text-sm ${highlight ? "text-foreground" : "text-muted-foreground"}`,
								children: "Per-unit pricing"
							}, void 0, false, {
								fileName: _jsxFileName$28,
								lineNumber: 150,
								columnNumber: 17
							}, this)]
						}, void 0, true, {
							fileName: _jsxFileName$28,
							lineNumber: 146,
							columnNumber: 15
						}, this),
						/* @__PURE__ */ jsxDEV("div", {
							className: "flex items-start gap-2",
							children: [/* @__PURE__ */ jsxDEV(Check, { className: `mt-0.5 h-5 w-5 shrink-0 ${highlight ? "text-foreground" : "text-muted-foreground"}` }, void 0, false, {
								fileName: _jsxFileName$28,
								lineNumber: 157,
								columnNumber: 17
							}, this), /* @__PURE__ */ jsxDEV("span", {
								className: `text-sm ${highlight ? "text-foreground" : "text-muted-foreground"}`,
								children: [
									billingScheme?.__typename === "ApiSubscriptionPlanPriceBillingSchemePerUnit" && billingScheme.usageType,
									" ",
									"billing"
								]
							}, void 0, true, {
								fileName: _jsxFileName$28,
								lineNumber: 160,
								columnNumber: 17
							}, this)]
						}, void 0, true, {
							fileName: _jsxFileName$28,
							lineNumber: 156,
							columnNumber: 15
						}, this),
						/* @__PURE__ */ jsxDEV("div", {
							className: "flex items-start gap-2",
							children: [/* @__PURE__ */ jsxDEV(Check, { className: `mt-0.5 h-5 w-5 shrink-0 ${highlight ? "text-foreground" : "text-muted-foreground"}` }, void 0, false, {
								fileName: _jsxFileName$28,
								lineNumber: 170,
								columnNumber: 17
							}, this), /* @__PURE__ */ jsxDEV("span", {
								className: `text-sm ${highlight ? "text-foreground" : "text-muted-foreground"}`,
								children: "Monthly recurring"
							}, void 0, false, {
								fileName: _jsxFileName$28,
								lineNumber: 173,
								columnNumber: 17
							}, this)]
						}, void 0, true, {
							fileName: _jsxFileName$28,
							lineNumber: 169,
							columnNumber: 15
						}, this)
					] }, void 0, true)
				}, void 0, false, {
					fileName: _jsxFileName$28,
					lineNumber: 115,
					columnNumber: 9
				}, this),
				/* @__PURE__ */ jsxDEV(Button$1, {
					onClick: () => onSubscribeClick?.(`${price.id}`),
					className: featured ? "w-full bg-primary text-primary-foreground hover:bg-primary/90" : "w-full bg-secondary text-secondary-foreground hover:bg-secondary/80",
					children: featured ? "Get Started" : "Choose Plan"
				}, void 0, false, {
					fileName: _jsxFileName$28,
					lineNumber: 183,
					columnNumber: 9
				}, this)
			]
		}, void 0, true, {
			fileName: _jsxFileName$28,
			lineNumber: 93,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$28,
		lineNumber: 78,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/subscriptions/pricing-table.tsx
var _jsxFileName$27 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/subscriptions/pricing-table.tsx";
var PricingTableFragment = graphql(`
  fragment PricingTableFragment on ApiSubscriptionPlanResult {
    __typename
    plans {
      description
      name
      prices {
        id
      }
      ...PricingCardFragment
    }
  }
`);
function PricingTable({ plansFragment, onSubscribeClick }) {
	const [interval, setInterval] = React.useState("MONTH");
	const { plans } = getFragmentData(PricingTableFragment, plansFragment);
	console.log(`🚀 - pricing-table.tsx:63 - PricingTable - plans:`, plans);
	return /* @__PURE__ */ jsxDEV("div", {
		className: "flex justify-center items-center flex-col gap-2 container mx-auto py-4",
		children: [/* @__PURE__ */ jsxDEV(ButtonGroup, { children: [/* @__PURE__ */ jsxDEV(Button$1, {
			variant: interval === "YEAR" ? "default" : "outline",
			onClick: () => setInterval("YEAR"),
			children: "Yearly"
		}, void 0, false, {
			fileName: _jsxFileName$27,
			lineNumber: 75,
			columnNumber: 9
		}, this), /* @__PURE__ */ jsxDEV(Button$1, {
			variant: interval === "MONTH" ? "default" : "outline",
			onClick: () => setInterval("MONTH"),
			children: "Monthly"
		}, void 0, false, {
			fileName: _jsxFileName$27,
			lineNumber: 81,
			columnNumber: 9
		}, this)] }, void 0, true, {
			fileName: _jsxFileName$27,
			lineNumber: 74,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV("div", {
			className: "grid gap-6 md:grid-cols-2 lg:grid-cols-3 w-full",
			children: plans.map((plan, index) => /* @__PURE__ */ jsxDEV(PricingCard, {
				highlight: index === 0,
				dbFragment: plan,
				featured: index === 0,
				interval,
				onSubscribeClick
			}, plan.prices[0]?.id || index, false, {
				fileName: _jsxFileName$27,
				lineNumber: 90,
				columnNumber: 11
			}, this))
		}, void 0, false, {
			fileName: _jsxFileName$27,
			lineNumber: 88,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$27,
		lineNumber: 73,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/sidebar-layout.tsx
var _jsxFileName$26 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/sidebar-layout.tsx";
function SidebarLayout({ children }) {
	return /* @__PURE__ */ jsxDEV(SidebarProvider, { children: [children[0], /* @__PURE__ */ jsxDEV("div", {
		className: " w-full max-h-full overflow-auto p-4",
		children: children[1]
	}, void 0, false, {
		fileName: _jsxFileName$26,
		lineNumber: 11,
		columnNumber: 7
	}, this)] }, void 0, true, {
		fileName: _jsxFileName$26,
		lineNumber: 9,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/search-combobox.tsx
var _jsxFileName$25 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/search-combobox.tsx";
function SearchCombobox({ value, items, onValueChange, onItemSelect, onSubmit, placeholder = "Search...", emptyText = "No results.", loadingText = "Searching...", loading = false, disabled = false, submitLabel = "Find", hideSubmitButton = false, className, inputClassName, contentClassName, anchorRef, sideOffset }) {
	const handleSubmit = (event) => {
		event.preventDefault();
		onSubmit?.();
	};
	return /* @__PURE__ */ jsxDEV("form", {
		className,
		onSubmit: handleSubmit,
		children: /* @__PURE__ */ jsxDEV("div", {
			className: "flex items-center gap-2",
			children: [/* @__PURE__ */ jsxDEV(Combobox, {
				items,
				filter: null,
				inputValue: value,
				itemToStringLabel: (item) => item.label,
				itemToStringValue: (item) => item.value ?? item.id,
				isItemEqualToValue: (a, b) => a.id === b.id,
				onInputValueChange: onValueChange,
				onValueChange: (item) => {
					if (!item) return;
					onValueChange(item.label);
					onItemSelect(item);
				},
				children: [/* @__PURE__ */ jsxDEV(ComboboxInput, {
					className: cn("w-full bg-background", inputClassName),
					disabled,
					placeholder,
					showClear: true,
					showTrigger: false
				}, void 0, false, {
					fileName: _jsxFileName$25,
					lineNumber: 109,
					columnNumber: 11
				}, this), /* @__PURE__ */ jsxDEV(ComboboxContent, {
					className: contentClassName,
					anchor: anchorRef,
					sideOffset,
					children: [/* @__PURE__ */ jsxDEV(ComboboxEmpty, { children: loading ? loadingText : emptyText }, void 0, false, {
						fileName: _jsxFileName$25,
						lineNumber: 121,
						columnNumber: 13
					}, this), /* @__PURE__ */ jsxDEV(ComboboxList, { children: (item) => /* @__PURE__ */ jsxDEV(ComboboxItem, {
						value: item,
						children: /* @__PURE__ */ jsxDEV("span", {
							className: "min-w-0 flex-1",
							children: [/* @__PURE__ */ jsxDEV("span", {
								className: "block truncate",
								children: item.title ?? item.label
							}, void 0, false, {
								fileName: _jsxFileName$25,
								lineNumber: 126,
								columnNumber: 21
							}, this), item.description ? /* @__PURE__ */ jsxDEV("span", {
								className: "text-muted-foreground block truncate text-[11px]",
								children: item.description
							}, void 0, false, {
								fileName: _jsxFileName$25,
								lineNumber: 130,
								columnNumber: 23
							}, this) : null]
						}, void 0, true, {
							fileName: _jsxFileName$25,
							lineNumber: 125,
							columnNumber: 19
						}, this)
					}, item.id, false, {
						fileName: _jsxFileName$25,
						lineNumber: 124,
						columnNumber: 17
					}, this) }, void 0, false, {
						fileName: _jsxFileName$25,
						lineNumber: 122,
						columnNumber: 13
					}, this)]
				}, void 0, true, {
					fileName: _jsxFileName$25,
					lineNumber: 116,
					columnNumber: 11
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$25,
				lineNumber: 86,
				columnNumber: 9
			}, this), onSubmit && !hideSubmitButton ? /* @__PURE__ */ jsxDEV(Button$1, {
				disabled: disabled || loading,
				type: "submit",
				children: submitLabel
			}, void 0, false, {
				fileName: _jsxFileName$25,
				lineNumber: 142,
				columnNumber: 11
			}, this) : null]
		}, void 0, true, {
			fileName: _jsxFileName$25,
			lineNumber: 85,
			columnNumber: 7
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$25,
		lineNumber: 84,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/floating-panel.tsx
var _jsxFileName$24 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/floating-panel.tsx";
function FloatingPanelRoot({ className, children }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("rounded-2xl border border-border bg-card/95 p-3 text-card-foreground shadow-lg backdrop-blur supports-[backdrop-filter]:bg-card/85", className),
		children
	}, void 0, false, {
		fileName: _jsxFileName$24,
		lineNumber: 15,
		columnNumber: 5
	}, this);
}
function FloatingPanelHeader({ eyebrow, title, status, className }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("mb-3 flex items-center justify-between", className),
		children: [/* @__PURE__ */ jsxDEV("div", {
			className: "min-w-0",
			children: [eyebrow ? /* @__PURE__ */ jsxDEV("div", {
				className: "text-muted-foreground text-[10px] font-semibold uppercase tracking-[0.22em]",
				children: eyebrow
			}, void 0, false, {
				fileName: _jsxFileName$24,
				lineNumber: 43,
				columnNumber: 11
			}, this) : null, title ? /* @__PURE__ */ jsxDEV("div", {
				className: "text-foreground truncate text-sm font-semibold",
				children: title
			}, void 0, false, {
				fileName: _jsxFileName$24,
				lineNumber: 48,
				columnNumber: 11
			}, this) : null]
		}, void 0, true, {
			fileName: _jsxFileName$24,
			lineNumber: 41,
			columnNumber: 7
		}, this), status ? /* @__PURE__ */ jsxDEV("div", {
			className: "shrink-0",
			children: status
		}, void 0, false, {
			fileName: _jsxFileName$24,
			lineNumber: 53,
			columnNumber: 17
		}, this) : null]
	}, void 0, true, {
		fileName: _jsxFileName$24,
		lineNumber: 40,
		columnNumber: 5
	}, this);
}
function FloatingPanelSection({ className, children }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("space-y-2", className),
		children
	}, void 0, false, {
		fileName: _jsxFileName$24,
		lineNumber: 66,
		columnNumber: 10
	}, this);
}
function FloatingPanelActions({ className, children }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("mt-3 flex flex-wrap gap-2", className),
		children
	}, void 0, false, {
		fileName: _jsxFileName$24,
		lineNumber: 78,
		columnNumber: 5
	}, this);
}
var floatingPanelNoticeToneClass = {
	neutral: "border-border bg-muted/60 text-foreground",
	info: "border-secondary bg-secondary/70 text-secondary-foreground",
	danger: "border-destructive/30 bg-destructive/10 text-destructive",
	success: "border-primary/30 bg-primary/10 text-primary"
};
function FloatingPanelNotice({ tone = "neutral", className, children }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("mt-2 rounded-lg border px-3 py-2 text-xs", floatingPanelNoticeToneClass[tone], className),
		children
	}, void 0, false, {
		fileName: _jsxFileName$24,
		lineNumber: 102,
		columnNumber: 5
	}, this);
}
function FloatingPanelSearchField({ label, className, ...searchComboboxProps }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("space-y-1", className),
		children: [label ? /* @__PURE__ */ jsxDEV("div", {
			className: "text-muted-foreground text-[11px] font-medium uppercase tracking-[0.12em]",
			children: label
		}, void 0, false, {
			fileName: _jsxFileName$24,
			lineNumber: 127,
			columnNumber: 9
		}, this) : null, /* @__PURE__ */ jsxDEV(SearchCombobox, {
			className: "w-full",
			...searchComboboxProps
		}, void 0, false, {
			fileName: _jsxFileName$24,
			lineNumber: 131,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$24,
		lineNumber: 125,
		columnNumber: 5
	}, this);
}
function IconDockRoot({ className, children }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("IconDockRoot", "rounded-2xl bg-background/90 p-2 shadow-lg backdrop-blur-md supports-[backdrop-filter]:bg-background/80", className),
		children: /* @__PURE__ */ jsxDEV("div", {
			className: "flex flex-col gap-2",
			children
		}, void 0, false, {
			fileName: _jsxFileName$24,
			lineNumber: 149,
			columnNumber: 7
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$24,
		lineNumber: 142,
		columnNumber: 5
	}, this);
}
function IconDockButton({ variant = "secondary", size = "icon", className, ...props }) {
	return /* @__PURE__ */ jsxDEV(Button, {
		variant,
		size,
		className: cn("h-10 w-10 rounded-xl border-0 bg-transparent text-foreground hover:bg-muted", className),
		...props
	}, void 0, false, {
		fileName: _jsxFileName$24,
		lineNumber: 163,
		columnNumber: 5
	}, this);
}
var FloatingPanel = Object.assign(FloatingPanelRoot, {
	Header: FloatingPanelHeader,
	Section: FloatingPanelSection,
	Actions: FloatingPanelActions,
	Notice: FloatingPanelNotice,
	SearchField: FloatingPanelSearchField
});
var IconDock = Object.assign(IconDockRoot, { Button: IconDockButton });
//#endregion
//#region src/design/organisms/floating-toolbar.tsx
var _jsxFileName$23 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/floating-toolbar.tsx";
function FloatingToolbarRoot({ solid = false, className, children, ...props }) {
	return /* @__PURE__ */ jsxDEV("header", {
		"data-solid": solid ? "true" : "false",
		className: cn("group/toolbar fixed inset-x-0 top-0 z-40 px-6 py-5 transition-[background-color,border-color,box-shadow,backdrop-filter] duration-200 md:px-10 md:py-6 data-[solid=true]:border-b data-[solid=true]:border-foreground/10 data-[solid=true]:bg-background/96 data-[solid=true]:shadow-[0_10px_30px_-24px_rgb(15_23_42_/_0.3)] data-[solid=true]:backdrop-blur-md", className),
		...props,
		children
	}, void 0, false, {
		fileName: _jsxFileName$23,
		lineNumber: 15,
		columnNumber: 5
	}, this);
}
function FloatingToolbarBrand({ className, ...props }) {
	return /* @__PURE__ */ jsxDEV("a", {
		className: cn("absolute left-6 top-5 inline-flex h-10 w-10 items-center justify-center md:left-10 md:top-6", className),
		...props
	}, void 0, false, {
		fileName: _jsxFileName$23,
		lineNumber: 33,
		columnNumber: 5
	}, this);
}
function FloatingToolbarCenter({ className, ...props }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("mx-auto flex w-full max-w-7xl items-center justify-center", className),
		...props
	}, void 0, false, {
		fileName: _jsxFileName$23,
		lineNumber: 48,
		columnNumber: 5
	}, this);
}
function FloatingToolbarNav({ className, ...props }) {
	return /* @__PURE__ */ jsxDEV("nav", {
		className: cn("flex items-center gap-[0.2rem]", className),
		...props
	}, void 0, false, {
		fileName: _jsxFileName$23,
		lineNumber: 63,
		columnNumber: 5
	}, this);
}
function FloatingToolbarLink({ active = false, className, ...props }) {
	return /* @__PURE__ */ jsxDEV("a", {
		className: cn("inline-flex h-11 items-center justify-center rounded-full border border-transparent px-4 text-sm font-medium text-primary-foreground/78 transition-colors [text-shadow:0_1px_2px_rgb(0_0_0_/_0.22)] hover:text-primary-foreground/94 group-data-[solid=true]/toolbar:text-foreground/88 group-data-[solid=true]/toolbar:[text-shadow:none]", active ? "border-primary-foreground/26 bg-primary/45 text-primary-foreground/98 shadow-[0_8px_20px_-16px_rgb(0_0_0_/_0.55)] group-data-[solid=true]/toolbar:border-foreground/10 group-data-[solid=true]/toolbar:bg-foreground/8" : "group-data-[solid=true]/toolbar:hover:bg-foreground/8", className),
		...props
	}, void 0, false, {
		fileName: _jsxFileName$23,
		lineNumber: 80,
		columnNumber: 5
	}, this);
}
function FloatingToolbarActions({ className, ...props }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("absolute right-6 top-[1.2rem] md:right-10 md:top-[1.45rem]", className),
		...props
	}, void 0, false, {
		fileName: _jsxFileName$23,
		lineNumber: 98,
		columnNumber: 5
	}, this);
}
var FloatingToolbar = Object.assign(FloatingToolbarRoot, {
	Brand: FloatingToolbarBrand,
	Center: FloatingToolbarCenter,
	Nav: FloatingToolbarNav,
	Link: FloatingToolbarLink,
	Actions: FloatingToolbarActions
});
//#endregion
//#region src/design/organisms/map-surface.tsx
var _jsxFileName$22 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/map-surface.tsx";
function MapSurfaceRoot({ className, children }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("relative h-full w-full overflow-hidden bg-muted/40 shadow-xl", className),
		children
	}, void 0, false, {
		fileName: _jsxFileName$22,
		lineNumber: 13,
		columnNumber: 5
	}, this);
}
function MapSurfaceViewport({ className, ref, ...props }) {
	return /* @__PURE__ */ jsxDEV("div", {
		ref,
		className: cn("h-full w-full", className),
		...props
	}, void 0, false, {
		fileName: _jsxFileName$22,
		lineNumber: 34,
		columnNumber: 5
	}, this);
}
var mapSurfaceGlowToneClass = {
	primary: "bg-[radial-gradient(120%_80%_at_50%_0%,hsl(var(--primary)/0.2),transparent)]",
	secondary: "bg-[radial-gradient(120%_80%_at_50%_0%,hsl(var(--secondary)/0.45),transparent)]",
	accent: "bg-[radial-gradient(120%_80%_at_50%_0%,hsl(var(--accent)/0.45),transparent)]"
};
function MapSurfaceGlow({ tone = "primary", className }) {
	return /* @__PURE__ */ jsxDEV("div", { className: cn("pointer-events-none absolute inset-0", mapSurfaceGlowToneClass[tone], className) }, void 0, false, {
		fileName: _jsxFileName$22,
		lineNumber: 59,
		columnNumber: 5
	}, this);
}
var MapSurface = Object.assign(MapSurfaceRoot, {
	Viewport: MapSurfaceViewport,
	Glow: MapSurfaceGlow
});
//#endregion
//#region src/design/organisms/map-route-legend.tsx
var _jsxFileName$21 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/map-route-legend.tsx";
var DEFAULT_LABEL = "Roads Chip can use";
/**
* Small floating legend that tells users the green road overlay marks the
* low-speed streets Chip is allowed to drive. Visually paired with the
* `IconDock` styling so it reads as part of the same map UI family.
*/
function MapRouteLegend({ className, label = DEFAULT_LABEL }) {
	return /* @__PURE__ */ jsxDEV("div", {
		role: "img",
		"aria-label": `${label}. The green road segments on the map mark drivable streets.`,
		className: cn("MapRouteLegend", "flex h-10 items-center gap-2 rounded-full bg-background/90 px-3 shadow-lg backdrop-blur-md supports-[backdrop-filter]:bg-background/80", className),
		children: [/* @__PURE__ */ jsxDEV("span", {
			"aria-hidden": true,
			className: "block h-5 w-7 rounded-md",
			style: { backgroundColor: ROAD_OVERLAY_LOW_SPEED_COLOR }
		}, void 0, false, {
			fileName: _jsxFileName$21,
			lineNumber: 31,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV("span", {
			className: "text-foreground text-sm font-medium leading-none",
			children: label
		}, void 0, false, {
			fileName: _jsxFileName$21,
			lineNumber: 36,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$21,
		lineNumber: 22,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/templates/prelaunch-hero-scene.tsx
var _jsxFileName$20 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/templates/prelaunch-hero-scene.tsx";
function PrelaunchHeroScene({ background, cta, subtitle, title }) {
	return /* @__PURE__ */ jsxDEV("main", {
		className: "prelaunch-page",
		children: [/* @__PURE__ */ jsxDEV("div", {
			"aria-hidden": "true",
			className: "prelaunch-background",
			children: [background, /* @__PURE__ */ jsxDEV("div", { className: "prelaunch-background-scrim" }, void 0, false, {
				fileName: _jsxFileName$20,
				lineNumber: 20,
				columnNumber: 9
			}, this)]
		}, void 0, true, {
			fileName: _jsxFileName$20,
			lineNumber: 18,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV("div", {
			className: "prelaunch-stage",
			children: [/* @__PURE__ */ jsxDEV("div", {
				className: "prelaunch-title-wrap",
				children: /* @__PURE__ */ jsxDEV("h1", {
					className: "prelaunch-title",
					children: title
				}, void 0, false, {
					fileName: _jsxFileName$20,
					lineNumber: 25,
					columnNumber: 11
				}, this)
			}, void 0, false, {
				fileName: _jsxFileName$20,
				lineNumber: 24,
				columnNumber: 9
			}, this), /* @__PURE__ */ jsxDEV("div", {
				className: "prelaunch-body",
				children: [/* @__PURE__ */ jsxDEV("p", {
					className: "prelaunch-subtitle",
					children: subtitle
				}, void 0, false, {
					fileName: _jsxFileName$20,
					lineNumber: 29,
					columnNumber: 11
				}, this), /* @__PURE__ */ jsxDEV("div", {
					className: "prelaunch-action",
					children: cta
				}, void 0, false, {
					fileName: _jsxFileName$20,
					lineNumber: 30,
					columnNumber: 11
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$20,
				lineNumber: 28,
				columnNumber: 9
			}, this)]
		}, void 0, true, {
			fileName: _jsxFileName$20,
			lineNumber: 23,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$20,
		lineNumber: 17,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/pages/email-table.tsx
var _jsxFileName$19 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/pages/email-table.tsx";
var columnHelper$1 = createColumnHelper();
function EmailTable({ data, LinkComponent }) {
	const columns = React.useMemo(() => [
		columnHelper$1.accessor("email_from", { header: "From" }),
		columnHelper$1.accessor("email_sent_dt", {
			header: "Item Name",
			cell: ({ cell, row }) => /* @__PURE__ */ jsxDEV(LinkComponent, {
				email: row.original,
				children: fmtDt(cell.getValue()) ?? ""
			}, void 0, false, {
				fileName: _jsxFileName$19,
				lineNumber: 30,
				columnNumber: 11
			}, this)
		}),
		columnHelper$1.accessor("email_subject", {
			header: "Subject",
			cell: ({ cell, row }) => /* @__PURE__ */ jsxDEV(LinkComponent, {
				email: row.original,
				children: cell.getValue()
			}, void 0, false, {
				fileName: _jsxFileName$19,
				lineNumber: 38,
				columnNumber: 11
			}, this)
		})
	], [LinkComponent]);
	return /* @__PURE__ */ jsxDEV("div", {
		className: "p-4",
		children: [/* @__PURE__ */ jsxDEV(H1, { children: "Emails" }, void 0, false, {
			fileName: _jsxFileName$19,
			lineNumber: 53,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV(DataTable, {
			columns,
			data
		}, void 0, false, {
			fileName: _jsxFileName$19,
			lineNumber: 54,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$19,
		lineNumber: 52,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/pages/google-sign-in.tsx
var _jsxFileName$18 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/pages/google-sign-in.tsx";
function GoogleSignIn({ onSignIn }) {
	return /* @__PURE__ */ jsxDEV(FullPageCard, {
		header: {
			title: "strut live",
			description: "log in with google"
		},
		footer: /* @__PURE__ */ jsxDEV(Button$1, {
			className: "w-full",
			onClick: onSignIn,
			children: [/* @__PURE__ */ jsxDEV("svg", {
				className: "mr-2 h-4 w-4",
				"aria-hidden": "true",
				focusable: "false",
				"data-prefix": "fab",
				"data-icon": "google",
				role: "img",
				xmlns: "http://www.w3.org/2000/svg",
				viewBox: "0 0 488 512",
				children: /* @__PURE__ */ jsxDEV("path", {
					fill: "currentColor",
					d: "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
				}, void 0, false, {
					fileName: _jsxFileName$18,
					lineNumber: 23,
					columnNumber: 13
				}, this)
			}, void 0, false, {
				fileName: _jsxFileName$18,
				lineNumber: 13,
				columnNumber: 11
			}, this), "Sign in with Google"]
		}, void 0, true, {
			fileName: _jsxFileName$18,
			lineNumber: 12,
			columnNumber: 9
		}, this),
		children: /* @__PURE__ */ jsxDEV("div", {
			className: "w-full h-40 mb-4 bg-blue-200 rounded-lg flex items-center justify-center",
			children: /* @__PURE__ */ jsxDEV("svg", {
				xmlns: "http://www.w3.org/2000/svg",
				fill: "none",
				viewBox: "0 0 24 24",
				strokeWidth: 1.5,
				stroke: "currentColor",
				className: "w-24 h-24 text-blue-500",
				children: /* @__PURE__ */ jsxDEV("path", {
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
				}, void 0, false, {
					fileName: _jsxFileName$18,
					lineNumber: 41,
					columnNumber: 11
				}, this)
			}, void 0, false, {
				fileName: _jsxFileName$18,
				lineNumber: 33,
				columnNumber: 9
			}, this)
		}, void 0, false, {
			fileName: _jsxFileName$18,
			lineNumber: 32,
			columnNumber: 7
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$18,
		lineNumber: 6,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/pages/login-page.tsx
var _jsxFileName$17 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/pages/login-page.tsx";
var formSchemaEmailOnly = type({
	email: type("string.email").configure({ message: "Invalid email address" }),
	password: type("string")
});
var formSchemaPassword = type({
	email: type("string.email").configure({ message: "Invalid email address" }),
	password: type("string >= 6").configure({ message: "Password must be at least 6 characters long" })
});
function SignInPage({ onSignIn, children, password, error, defaultEmail, separateSigninSignup }) {
	const form = useForm({
		resolver: arktypeResolver(password ? formSchemaPassword : formSchemaEmailOnly),
		defaultValues: {
			email: defaultEmail ?? "",
			password: ""
		},
		mode: "onTouched"
	});
	return /* @__PURE__ */ jsxDEV(Form, {
		...form,
		children: /* @__PURE__ */ jsxDEV("form", {
			onSubmit: form.handleSubmit(({ email, password }) => onSignIn(email, password)),
			className: "space-y-6",
			children: /* @__PURE__ */ jsxDEV(FullPageCard, {
				header: {
					title: "strut live",
					description: "log in with email"
				},
				footer: /* @__PURE__ */ jsxDEV("div", { children: /* @__PURE__ */ jsxDEV(SpinnerButton, {
					className: "w-full",
					onClickAsync: form.handleSubmit(({ email, password }) => onSignIn(email, password)),
					disabled: form.formState.isSubmitting || !form.formState.isValid,
					forceLoading: form.formState.isSubmitting,
					children: separateSigninSignup ? "Sign In / Sign Up" : "Sign In"
				}, void 0, false, {
					fileName: _jsxFileName$17,
					lineNumber: 86,
					columnNumber: 15
				}, this) }, void 0, false, {
					fileName: _jsxFileName$17,
					lineNumber: 85,
					columnNumber: 13
				}, this),
				children: [
					/* @__PURE__ */ jsxDEV(FormField, {
						control: form.control,
						name: "email",
						render: ({ field }) => /* @__PURE__ */ jsxDEV(FormItem, {
							className: "max-w-full",
							children: [
								/* @__PURE__ */ jsxDEV(FormLabel, {
									htmlFor: "email",
									children: "Email"
								}, void 0, false, {
									fileName: _jsxFileName$17,
									lineNumber: 107,
									columnNumber: 17
								}, this),
								/* @__PURE__ */ jsxDEV(FormControl, { children: /* @__PURE__ */ jsxDEV(Input, {
									placeholder: "bob@example.com",
									...field
								}, void 0, false, {
									fileName: _jsxFileName$17,
									lineNumber: 109,
									columnNumber: 19
								}, this) }, void 0, false, {
									fileName: _jsxFileName$17,
									lineNumber: 108,
									columnNumber: 17
								}, this),
								/* @__PURE__ */ jsxDEV(FormMessage, { className: "" }, void 0, false, {
									fileName: _jsxFileName$17,
									lineNumber: 111,
									columnNumber: 17
								}, this)
							]
						}, void 0, true, {
							fileName: _jsxFileName$17,
							lineNumber: 106,
							columnNumber: 15
						}, this)
					}, void 0, false, {
						fileName: _jsxFileName$17,
						lineNumber: 102,
						columnNumber: 11
					}, this),
					password && /* @__PURE__ */ jsxDEV(FormField, {
						control: form.control,
						name: "password",
						render: ({ field }) => /* @__PURE__ */ jsxDEV(FormItem, {
							className: "max-w-full",
							children: [
								/* @__PURE__ */ jsxDEV(FormLabel, {
									htmlFor: "password",
									children: "Password"
								}, void 0, false, {
									fileName: _jsxFileName$17,
									lineNumber: 121,
									columnNumber: 19
								}, this),
								/* @__PURE__ */ jsxDEV(FormControl, { children: /* @__PURE__ */ jsxDEV(Input, {
									placeholder: "••••••••",
									type: "password",
									...field
								}, void 0, false, {
									fileName: _jsxFileName$17,
									lineNumber: 123,
									columnNumber: 21
								}, this) }, void 0, false, {
									fileName: _jsxFileName$17,
									lineNumber: 122,
									columnNumber: 19
								}, this),
								/* @__PURE__ */ jsxDEV(FormMessage, {
									className: "text-red-500",
									children: error ?? "\xA0"
								}, void 0, false, {
									fileName: _jsxFileName$17,
									lineNumber: 126,
									columnNumber: 19
								}, this)
							]
						}, void 0, true, {
							fileName: _jsxFileName$17,
							lineNumber: 120,
							columnNumber: 17
						}, this)
					}, void 0, false, {
						fileName: _jsxFileName$17,
						lineNumber: 116,
						columnNumber: 13
					}, this),
					children,
					/* @__PURE__ */ jsxDEV(DevTool, { control: form.control }, void 0, false, {
						fileName: _jsxFileName$17,
						lineNumber: 134,
						columnNumber: 11
					}, this)
				]
			}, void 0, true, {
				fileName: _jsxFileName$17,
				lineNumber: 79,
				columnNumber: 9
			}, this)
		}, void 0, false, {
			fileName: _jsxFileName$17,
			lineNumber: 73,
			columnNumber: 7
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$17,
		lineNumber: 72,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/molecules/organization/name-form.tsx
var _jsxFileName$16 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/organization/name-form.tsx";
var OrganizationNameFragment = graphql(`
  fragment OrganizationNameFragment on Organizations {
    id
    name
  }
`);
function OrganizationNameForm({ dbNameFragment, onUpdateOrganizationName }) {
	const { name: dbName } = getFragmentData(OrganizationNameFragment, dbNameFragment);
	const [nameState, setNameState] = useState(dbName);
	const [isLoading, setIsLoading] = useState(false);
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!nameState.trim()) return;
		setIsLoading(true);
		try {
			await onUpdateOrganizationName(nameState);
			toast$1("Organization name updated", { description: "Your organization name has been successfully updated." });
		} catch (error) {
			toast$1("Failed to update", { description: "There was an error updating your organization name." });
		} finally {
			setIsLoading(false);
		}
	};
	return /* @__PURE__ */ jsxDEV("form", {
		onSubmit: handleSubmit,
		className: "space-y-4",
		children: [/* @__PURE__ */ jsxDEV("div", {
			className: "space-y-2",
			children: [/* @__PURE__ */ jsxDEV(Label, {
				htmlFor: "org-name",
				children: "Organization Name"
			}, void 0, false, {
				fileName: _jsxFileName$16,
				lineNumber: 62,
				columnNumber: 9
			}, this), /* @__PURE__ */ jsxDEV(Input, {
				id: "org-name",
				value: nameState,
				onChange: (e) => setNameState(e.target.value),
				placeholder: "Enter organization name"
			}, void 0, false, {
				fileName: _jsxFileName$16,
				lineNumber: 63,
				columnNumber: 9
			}, this)]
		}, void 0, true, {
			fileName: _jsxFileName$16,
			lineNumber: 61,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV(Button$1, {
			type: "submit",
			disabled: isLoading || nameState === dbName,
			children: isLoading ? "Saving..." : "Save Changes"
		}, void 0, false, {
			fileName: _jsxFileName$16,
			lineNumber: 70,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$16,
		lineNumber: 60,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/molecules/invite-form.tsx
var _jsxFileName$15 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/invite-form.tsx";
function InviteForm({ onInvite }) {
	const [email, setEmail] = useState("");
	const [role, setRole] = useState("staff");
	const [isLoading, setIsLoading] = useState(false);
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!email.trim()) return;
		setIsLoading(true);
		try {
			await onInvite(email, role);
			toast$1("Invitation sent", { description: `An invitation has been sent to ${email}.` });
			setEmail("");
		} catch (error) {
			toast$1.error("Failed to send invitation", { description: "There was an error sending the invitation." });
		} finally {
			setIsLoading(false);
		}
	};
	return /* @__PURE__ */ jsxDEV("form", {
		onSubmit: handleSubmit,
		className: "space-y-4",
		children: [
			/* @__PURE__ */ jsxDEV("div", {
				className: "space-y-2",
				children: [/* @__PURE__ */ jsxDEV(Label, {
					htmlFor: "email",
					children: "Email Address"
				}, void 0, false, {
					fileName: _jsxFileName$15,
					lineNumber: 54,
					columnNumber: 9
				}, this), /* @__PURE__ */ jsxDEV(Input, {
					id: "email",
					type: "email",
					value: email,
					onChange: (e) => setEmail(e.target.value),
					placeholder: "colleague@example.com",
					required: true
				}, void 0, false, {
					fileName: _jsxFileName$15,
					lineNumber: 55,
					columnNumber: 9
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$15,
				lineNumber: 53,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV("div", {
				className: "space-y-2",
				children: [/* @__PURE__ */ jsxDEV(Label, {
					htmlFor: "role",
					children: "Role"
				}, void 0, false, {
					fileName: _jsxFileName$15,
					lineNumber: 65,
					columnNumber: 9
				}, this), /* @__PURE__ */ jsxDEV(Select, {
					defaultValue: role,
					value: role,
					onValueChange: (value) => setRole(value),
					children: [/* @__PURE__ */ jsxDEV(SelectTrigger, { children: /* @__PURE__ */ jsxDEV(SelectValue, {}, void 0, false, {
						fileName: _jsxFileName$15,
						lineNumber: 72,
						columnNumber: 13
					}, this) }, void 0, false, {
						fileName: _jsxFileName$15,
						lineNumber: 71,
						columnNumber: 11
					}, this), /* @__PURE__ */ jsxDEV(SelectContent, { children: /* @__PURE__ */ jsxDEV(SelectGroup, { children: [
						/* @__PURE__ */ jsxDEV(SelectLabel, { children: "Role" }, void 0, false, {
							fileName: _jsxFileName$15,
							lineNumber: 77,
							columnNumber: 15
						}, this),
						/* @__PURE__ */ jsxDEV(SelectItem, {
							value: "admin",
							children: "Admin"
						}, void 0, false, {
							fileName: _jsxFileName$15,
							lineNumber: 78,
							columnNumber: 15
						}, this),
						/* @__PURE__ */ jsxDEV(SelectItem, {
							value: "staff",
							children: "Staff"
						}, void 0, false, {
							fileName: _jsxFileName$15,
							lineNumber: 79,
							columnNumber: 15
						}, this)
					] }, void 0, true, {
						fileName: _jsxFileName$15,
						lineNumber: 76,
						columnNumber: 13
					}, this) }, void 0, false, {
						fileName: _jsxFileName$15,
						lineNumber: 75,
						columnNumber: 11
					}, this)]
				}, void 0, true, {
					fileName: _jsxFileName$15,
					lineNumber: 66,
					columnNumber: 9
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$15,
				lineNumber: 64,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV(Button$1, {
				type: "submit",
				disabled: isLoading || !email.trim(),
				children: isLoading ? "Sending..." : "Send Invitation"
			}, void 0, false, {
				fileName: _jsxFileName$15,
				lineNumber: 84,
				columnNumber: 7
			}, this)
		]
	}, void 0, true, {
		fileName: _jsxFileName$15,
		lineNumber: 52,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/molecules/member-actions.tsx
var _jsxFileName$14 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/member-actions.tsx";
function MemberActions({ member, currentUserRole, onUpdateMemberRole, onRemoveMember }) {
	const canManageRoles = currentUserRole === "owner" || currentUserRole === "admin" && member.role === "customer";
	const canRemove = currentUserRole === "owner" || currentUserRole === "admin" && member.role === "customer";
	if (!canManageRoles && !canRemove) return /* @__PURE__ */ jsxDEV(React.Fragment, {}, void 0, false, {
		fileName: _jsxFileName$14,
		lineNumber: 38,
		columnNumber: 45
	}, this);
	return /* @__PURE__ */ jsxDEV(DropdownMenu, { children: [/* @__PURE__ */ jsxDEV(DropdownMenuTrigger, { render: /* @__PURE__ */ jsxDEV(Button$1, {
		variant: "ghost",
		size: "icon",
		children: [/* @__PURE__ */ jsxDEV(MoreHorizontal, { className: "h-4 w-4" }, void 0, false, {
			fileName: _jsxFileName$14,
			lineNumber: 45,
			columnNumber: 13
		}, this), /* @__PURE__ */ jsxDEV("span", {
			className: "sr-only",
			children: "Open menu"
		}, void 0, false, {
			fileName: _jsxFileName$14,
			lineNumber: 46,
			columnNumber: 13
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$14,
		lineNumber: 44,
		columnNumber: 11
	}, this) }, void 0, false, {
		fileName: _jsxFileName$14,
		lineNumber: 42,
		columnNumber: 7
	}, this), /* @__PURE__ */ jsxDEV(DropdownMenuContent, {
		align: "end",
		children: [canManageRoles && member.role !== "owner" && /* @__PURE__ */ jsxDEV(Fragment, { children: [member.role !== "admin" && /* @__PURE__ */ jsxDEV(DropdownMenuItem, {
			onClick: () => onUpdateMemberRole(member.profileId, "admin"),
			children: "Make Admin"
		}, void 0, false, {
			fileName: _jsxFileName$14,
			lineNumber: 54,
			columnNumber: 15
		}, this), member.role !== "customer" && /* @__PURE__ */ jsxDEV(DropdownMenuItem, {
			onClick: () => onUpdateMemberRole(member.profileId, "customer"),
			children: "Make Member"
		}, void 0, false, {
			fileName: _jsxFileName$14,
			lineNumber: 61,
			columnNumber: 15
		}, this)] }, void 0, true), canRemove && /* @__PURE__ */ jsxDEV(DropdownMenuItem, {
			className: "text-destructive focus:text-destructive",
			onClick: () => onRemoveMember(member.profileId),
			children: "Remove Member"
		}, void 0, false, {
			fileName: _jsxFileName$14,
			lineNumber: 70,
			columnNumber: 11
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$14,
		lineNumber: 50,
		columnNumber: 7
	}, this)] }, void 0, true, {
		fileName: _jsxFileName$14,
		lineNumber: 41,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/molecules/member-display.tsx
var _jsxFileName$13 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/molecules/member-display.tsx";
var getInitials = (name) => !name ? null : name.split(" ").map((n) => n[0]).join("").toUpperCase().substring(0, 2);
function MemberDisplay({ member }) {
	if (!member.profile) return /* @__PURE__ */ jsxDEV(Fragment, {}, void 0, false);
	return /* @__PURE__ */ jsxDEV("div", {
		className: "flex items-center gap-3",
		children: [/* @__PURE__ */ jsxDEV(Avatar, { children: [/* @__PURE__ */ jsxDEV(AvatarImage, {
			src: member.profile.avatarUrl ?? "",
			alt: member.profile.name ?? void 0
		}, void 0, false, {
			fileName: _jsxFileName$13,
			lineNumber: 27,
			columnNumber: 9
		}, this), /* @__PURE__ */ jsxDEV(AvatarFallback, { children: getInitials(member.profile.name) }, void 0, false, {
			fileName: _jsxFileName$13,
			lineNumber: 31,
			columnNumber: 9
		}, this)] }, void 0, true, {
			fileName: _jsxFileName$13,
			lineNumber: 26,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV("div", { children: [/* @__PURE__ */ jsxDEV("div", {
			className: "font-medium",
			children: member.profile.name
		}, void 0, false, {
			fileName: _jsxFileName$13,
			lineNumber: 34,
			columnNumber: 9
		}, this), /* @__PURE__ */ jsxDEV("div", {
			className: "text-sm text-muted-foreground",
			children: member.profile.email
		}, void 0, false, {
			fileName: _jsxFileName$13,
			lineNumber: 35,
			columnNumber: 9
		}, this)] }, void 0, true, {
			fileName: _jsxFileName$13,
			lineNumber: 33,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$13,
		lineNumber: 25,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/organization/member-columns.tsx
var _jsxFileName$12 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/organization/member-columns.tsx";
function getMemberColumns(currentUserRole, actions) {
	return [
		{
			accessorKey: "name",
			header: "Name",
			cell: ({ row }) => /* @__PURE__ */ jsxDEV(MemberDisplay, { member: row.original }, void 0, false, {
				fileName: _jsxFileName$12,
				lineNumber: 22,
				columnNumber: 26
			}, this)
		},
		{
			accessorKey: "role",
			header: "Role",
			cell: ({ row }) => /* @__PURE__ */ jsxDEV(RoleBadge, { role: row.original.role }, void 0, false, {
				fileName: _jsxFileName$12,
				lineNumber: 27,
				columnNumber: 26
			}, this)
		},
		{
			id: "actions",
			cell: ({ row }) => /* @__PURE__ */ jsxDEV(MemberActions, {
				member: row.original,
				currentUserRole,
				...actions
			}, void 0, false, {
				fileName: _jsxFileName$12,
				lineNumber: 32,
				columnNumber: 9
			}, this)
		}
	];
}
//#endregion
//#region src/design/organisms/organization/member-list.tsx
var _jsxFileName$11 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/organization/member-list.tsx";
var OrganizationMemberListFragment = graphql(`
  fragment OrganizationMemberListFragment on Organizations {
    id
    members: organizationMembersCollection {
      edges {
        node {
          id
          profileId
          role
          ...OrganizationMemberFragment
        }
      }
    }
  }
`);
function MemberList({ dbFragment, myId, onUpdateMemberRole, onRemoveMember }) {
	const data = getFragmentData(OrganizationMemberListFragment, dbFragment);
	const currentUserRole = data.members?.edges?.filter?.((m) => m.node?.profileId === myId)[0]?.node?.role ?? "staff";
	return /* @__PURE__ */ jsxDEV(DataTable, {
		columns: React.useMemo(() => getMemberColumns(currentUserRole, {
			onUpdateMemberRole,
			onRemoveMember
		}), [
			currentUserRole,
			onUpdateMemberRole,
			onRemoveMember
		]),
		data: data.members?.edges.map((e) => e.node) ?? []
	}, void 0, false, {
		fileName: _jsxFileName$11,
		lineNumber: 46,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/atoms/page-container.tsx
var _jsxFileName$10 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/atoms/page-container.tsx";
function PageContainer({ children, className }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: cn("container py-10", className),
		children
	}, void 0, false, {
		fileName: _jsxFileName$10,
		lineNumber: 8,
		columnNumber: 10
	}, this);
}
//#endregion
//#region src/design/organisms/organization/pending-invite-list.tsx
var _jsxFileName$9 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/organization/pending-invite-list.tsx";
var OrganizationInviteListFragment = graphql(`
  fragment OrganizationInviteListFragment on Organizations {
    id
    invites: organizationInvitationsCollection {
      edges {
        node {
          id
          createdAt
          role
          status
          email
          invitationOwnerProfile {
            id
            email
            name
          }
          invitedProfile {
            id
            email
            name
          }
        }
      }
    }
  }
`);
var columnHelper = createColumnHelper();
function useInvitationColumns(onRevoke) {
	return React.useMemo(() => [
		columnHelper.accessor("createdAt", {
			header: "Sent",
			cell: (info) => fmtDt(info.getValue())
		}),
		columnHelper.accessor("email", {
			header: "Email",
			cell: (info) => info.getValue()
		}),
		columnHelper.accessor("role", {
			header: "Role",
			cell: ({ row }) => /* @__PURE__ */ jsxDEV(RoleBadge, { role: row.original.role }, void 0, false, {
				fileName: _jsxFileName$9,
				lineNumber: 64,
				columnNumber: 28
			}, this)
		}),
		columnHelper.accessor("status", {
			header: "Status",
			cell: (props) => match(props.row.original.status).with("pending", () => "Pending").with("accepted", () => "Accepted").with("expired", () => "Expired").exhaustive()
		}),
		columnHelper.display({
			id: "actions",
			header: "Actions",
			cell: (info) => /* @__PURE__ */ jsxDEV(SpinnerButton, {
				variant: "destructive",
				size: "sm",
				disabled: info.row.original.status !== "pending",
				className: info.row.original.status === "pending" ? "" : "!opacity-0",
				onClickAsync: () => onRevoke(info.row.original.id).then(() => toast$1.warning("Revoked Invitation")),
				children: "Revoke"
			}, void 0, false, {
				fileName: _jsxFileName$9,
				lineNumber: 80,
				columnNumber: 11
			}, this)
		})
	], [onRevoke]);
}
function PendingInviteList({ dbFragment, onRevoke }) {
	return /* @__PURE__ */ jsxDEV(DataTable, {
		columns: useInvitationColumns(onRevoke),
		data: getFragmentData(OrganizationInviteListFragment, dbFragment).invites?.edges.map((e) => e.node) ?? []
	}, void 0, false, {
		fileName: _jsxFileName$9,
		lineNumber: 128,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/atoms/section-container.tsx
var _jsxFileName$8 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/atoms/section-container.tsx";
function SectionContainer({ children, className }) {
	return /* @__PURE__ */ jsxDEV("section", {
		className: cn("mb-10", className),
		children
	}, void 0, false, {
		fileName: _jsxFileName$8,
		lineNumber: 8,
		columnNumber: 10
	}, this);
}
//#endregion
//#region src/design/atoms/section-header.tsx
var _jsxFileName$7 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/atoms/section-header.tsx";
function SectionHeader({ title, description }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: "mb-6",
		children: [/* @__PURE__ */ jsxDEV("h2", {
			className: "text-2xl font-bold",
			children: title
		}, void 0, false, {
			fileName: _jsxFileName$7,
			lineNumber: 12,
			columnNumber: 7
		}, this), description && /* @__PURE__ */ jsxDEV("p", {
			className: "text-muted-foreground mt-1",
			children: description
		}, void 0, false, {
			fileName: _jsxFileName$7,
			lineNumber: 14,
			columnNumber: 9
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$7,
		lineNumber: 11,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/pages/organization.tsx
var _jsxFileName$6 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/pages/organization.tsx";
var OrganizationPageFragment = graphql(`
  fragment OrganizationPageFragment on Organizations {
    id
    ...OrganizationNameFragment
    ...OrganizationMemberListFragment
    ...OrganizationInviteListFragment
  }
`);
function OrganizationPage({ organizationFragment, onUpdateOrganizationName, onUpdateMemberRole, onInviteMember, onRevokeInvitation, onRemoveMember, myId }) {
	const organization = getFragmentData(OrganizationPageFragment, organizationFragment);
	return /* @__PURE__ */ jsxDEV(PageContainer, { children: [
		/* @__PURE__ */ jsxDEV(PageHeader, { title: "Organization Settings" }, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 55,
			columnNumber: 7
		}, this),
		/* @__PURE__ */ jsxDEV(SectionContainer, { children: [/* @__PURE__ */ jsxDEV(SectionHeader, {
			title: "General Settings",
			description: "Manage your organization's basic information."
		}, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 58,
			columnNumber: 9
		}, this), /* @__PURE__ */ jsxDEV(CardContainer, { children: /* @__PURE__ */ jsxDEV(OrganizationNameForm, {
			dbNameFragment: organization,
			onUpdateOrganizationName
		}, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 63,
			columnNumber: 11
		}, this) }, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 62,
			columnNumber: 9
		}, this)] }, void 0, true, {
			fileName: _jsxFileName$6,
			lineNumber: 57,
			columnNumber: 7
		}, this),
		/* @__PURE__ */ jsxDEV(SectionContainer, { children: [/* @__PURE__ */ jsxDEV(SectionHeader, {
			title: "Members",
			description: "Manage your organization's members and their roles."
		}, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 71,
			columnNumber: 9
		}, this), /* @__PURE__ */ jsxDEV(CardContainer, { children: /* @__PURE__ */ jsxDEV(MemberList, {
			myId,
			dbFragment: organization,
			onUpdateMemberRole,
			onRemoveMember
		}, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 76,
			columnNumber: 11
		}, this) }, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 75,
			columnNumber: 9
		}, this)] }, void 0, true, {
			fileName: _jsxFileName$6,
			lineNumber: 70,
			columnNumber: 7
		}, this),
		/* @__PURE__ */ jsxDEV(SectionContainer, { children: [/* @__PURE__ */ jsxDEV(SectionHeader, {
			title: "Invite Members",
			description: "Invite new members to join your organization."
		}, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 85,
			columnNumber: 9
		}, this), /* @__PURE__ */ jsxDEV(CardContainer, { children: /* @__PURE__ */ jsxDEV(InviteForm, { onInvite: onInviteMember }, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 90,
			columnNumber: 11
		}, this) }, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 89,
			columnNumber: 9
		}, this)] }, void 0, true, {
			fileName: _jsxFileName$6,
			lineNumber: 84,
			columnNumber: 7
		}, this),
		/* @__PURE__ */ jsxDEV(SectionContainer, { children: [/* @__PURE__ */ jsxDEV(SectionHeader, {
			title: "Existing Invitations",
			description: "Invitations for new team members to join your organization."
		}, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 94,
			columnNumber: 9
		}, this), /* @__PURE__ */ jsxDEV(CardContainer, { children: /* @__PURE__ */ jsxDEV(PendingInviteList, {
			dbFragment: organization,
			myId,
			onRevoke: onRevokeInvitation
		}, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 99,
			columnNumber: 11
		}, this) }, void 0, false, {
			fileName: _jsxFileName$6,
			lineNumber: 98,
			columnNumber: 9
		}, this)] }, void 0, true, {
			fileName: _jsxFileName$6,
			lineNumber: 93,
			columnNumber: 7
		}, this)
	] }, void 0, true, {
		fileName: _jsxFileName$6,
		lineNumber: 54,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/pages/otp-entry-page.tsx
var _jsxFileName$5 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/pages/otp-entry-page.tsx";
var formSchema = type({ otp: type("string.alphanumeric").exactlyLength(6).configure({ message: "Invalid OTP" }) });
function OtpEntryPage({ email, onResetEmail, onVerifyOtp }) {
	const form = useForm({
		resolver: arktypeResolver(formSchema),
		defaultValues: { otp: "" },
		mode: "onTouched"
	});
	return /* @__PURE__ */ jsxDEV(Form, {
		...form,
		children: /* @__PURE__ */ jsxDEV("form", {
			onSubmit: form.handleSubmit(({ otp }) => onVerifyOtp(otp)),
			children: /* @__PURE__ */ jsxDEV(FullPageCard, {
				header: {
					title: "strut live",
					description: email ?? "Verify Email"
				},
				footer: /* @__PURE__ */ jsxDEV("div", {
					className: "flex flex-col gap-2 w-full items-center",
					children: [/* @__PURE__ */ jsxDEV(SpinnerButton, {
						className: "w-full",
						disabled: form.formState.isSubmitting || !form.formState.isValid,
						forceLoading: form.formState.isSubmitting,
						children: "Verify OTP"
					}, void 0, false, {
						fileName: _jsxFileName$5,
						lineNumber: 53,
						columnNumber: 15
					}, this), /* @__PURE__ */ jsxDEV("a", {
						className: "cursor-pointer",
						onClick: onResetEmail,
						children: "reset"
					}, void 0, false, {
						fileName: _jsxFileName$5,
						lineNumber: 63,
						columnNumber: 15
					}, this)]
				}, void 0, true, {
					fileName: _jsxFileName$5,
					lineNumber: 52,
					columnNumber: 13
				}, this),
				children: [/* @__PURE__ */ jsxDEV(FormField, {
					control: form.control,
					name: "otp",
					render: ({ field }) => /* @__PURE__ */ jsxDEV(FormItem, {
						className: "justify-stretch",
						children: [/* @__PURE__ */ jsxDEV(FormControl, { children: /* @__PURE__ */ jsxDEV("div", {
							className: "px-3  py-5 flex flex-row items-center justify-center w-full border rounded-md",
							children: /* @__PURE__ */ jsxDEV(InputOtp, {
								className: "mx-auto",
								...field
							}, void 0, false, {
								fileName: _jsxFileName$5,
								lineNumber: 76,
								columnNumber: 21
							}, this)
						}, void 0, false, {
							fileName: _jsxFileName$5,
							lineNumber: 75,
							columnNumber: 19
						}, this) }, void 0, false, {
							fileName: _jsxFileName$5,
							lineNumber: 74,
							columnNumber: 17
						}, this), /* @__PURE__ */ jsxDEV(FormMessage, { className: "" }, void 0, false, {
							fileName: _jsxFileName$5,
							lineNumber: 80,
							columnNumber: 17
						}, this)]
					}, void 0, true, {
						fileName: _jsxFileName$5,
						lineNumber: 73,
						columnNumber: 15
					}, this)
				}, void 0, false, {
					fileName: _jsxFileName$5,
					lineNumber: 69,
					columnNumber: 11
				}, this), /* @__PURE__ */ jsxDEV(DevTool, { control: form.control }, void 0, false, {
					fileName: _jsxFileName$5,
					lineNumber: 84,
					columnNumber: 11
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$5,
				lineNumber: 46,
				columnNumber: 9
			}, this)
		}, void 0, false, {
			fileName: _jsxFileName$5,
			lineNumber: 45,
			columnNumber: 7
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$5,
		lineNumber: 44,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/pages/settings/stripe-connect.tsx
var _jsxFileName$4 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/pages/settings/stripe-connect.tsx";
var StripeAccountDetailsFragment = graphql(`
  fragment StripeAccountDetailsFragment on ApiStripeConnectedAccountResultSuccess {
    stripeAccountId
    stripeAccount {
      id
      email
      country
      defaultCurrency
      detailsSubmitted
      capabilities {
        cardPayments
        usBankTransfers
      }
      businessProfile {
        name
        url
      }
      created
    }
  }
`);
var StripeAccountFragment = graphql(`
  fragment StripeAccountFragment on ApiStripeConnectedAccountResult {
    ... on ApiStripeConnectedAccountResultNotSetup {
      message
    }
    ... on ApiStripeConnectedAccountResultSuccess {
      stripeAccountId
      ...StripeAccountDetailsFragment
    }
  }
`);
function StripeSettings({ loading, dbFragment, connecting, disconnecting, onConnect, onDisconnect, onOpenDashboard }) {
	if (loading) return /* @__PURE__ */ jsxDEV(StripeLoadingCard, {}, void 0, false, {
		fileName: _jsxFileName$4,
		lineNumber: 76,
		columnNumber: 23
	}, this);
	if (!dbFragment) return /* @__PURE__ */ jsxDEV(StripeLoadingCard, {}, void 0, false, {
		fileName: _jsxFileName$4,
		lineNumber: 77,
		columnNumber: 27
	}, this);
	const accountResult = getFragmentData(StripeAccountFragment, dbFragment);
	const account = accountResult.__typename === "ApiStripeConnectedAccountResultSuccess" ? accountResult : null;
	const accountUnwrapped = account ? getFragmentData(StripeAccountDetailsFragment, account) : null;
	return /* @__PURE__ */ jsxDEV(card_exports.Card, { children: [/* @__PURE__ */ jsxDEV(card_exports.CardHeader, { children: [/* @__PURE__ */ jsxDEV(card_exports.CardTitle, {
		className: "flex items-center gap-2",
		children: [/* @__PURE__ */ jsxDEV(CreditCard, { className: "h-5 w-5" }, void 0, false, {
			fileName: _jsxFileName$4,
			lineNumber: 91,
			columnNumber: 11
		}, this), "Stripe Integration"]
	}, void 0, true, {
		fileName: _jsxFileName$4,
		lineNumber: 90,
		columnNumber: 9
	}, this), /* @__PURE__ */ jsxDEV(card_exports.CardDescription, { children: "Manage your Stripe Connect account for payment processing" }, void 0, false, {
		fileName: _jsxFileName$4,
		lineNumber: 94,
		columnNumber: 9
	}, this)] }, void 0, true, {
		fileName: _jsxFileName$4,
		lineNumber: 89,
		columnNumber: 7
	}, this), /* @__PURE__ */ jsxDEV(card_exports.CardContent, {
		className: "space-y-6",
		children: !account || !accountUnwrapped ? /* @__PURE__ */ jsxDEV(StripeEmptyState, {
			connecting,
			onConnect
		}, void 0, false, {
			fileName: _jsxFileName$4,
			lineNumber: 100,
			columnNumber: 11
		}, this) : /* @__PURE__ */ jsxDEV("div", {
			className: "space-y-6",
			children: [
				/* @__PURE__ */ jsxDEV(StripeAccountDetailsGrid, { dbFragment: account }, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 108,
					columnNumber: 13
				}, this),
				/* @__PURE__ */ jsxDEV(Separator, {}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 110,
					columnNumber: 13
				}, this),
				/* @__PURE__ */ jsxDEV(StripeCapabilities, {
					cardsEnabled: accountUnwrapped?.stripeAccount?.capabilities?.cardPayments === "ACTIVE",
					bankTransfersEnabled: accountUnwrapped?.stripeAccount?.capabilities?.usBankTransfers === "ACTIVE"
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 112,
					columnNumber: 13
				}, this),
				/* @__PURE__ */ jsxDEV(Separator, {}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 128,
					columnNumber: 13
				}, this),
				/* @__PURE__ */ jsxDEV(StripeActions, {
					onManageAccount: onOpenDashboard,
					onDisconnect,
					disconnecting
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 130,
					columnNumber: 13
				}, this)
			]
		}, void 0, true, {
			fileName: _jsxFileName$4,
			lineNumber: 102,
			columnNumber: 11
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$4,
		lineNumber: 98,
		columnNumber: 7
	}, this)] }, void 0, true, {
		fileName: _jsxFileName$4,
		lineNumber: 88,
		columnNumber: 5
	}, this);
}
function StripeLoadingCard() {
	return /* @__PURE__ */ jsxDEV(card_exports.Card, { children: [/* @__PURE__ */ jsxDEV(card_exports.CardHeader, { children: /* @__PURE__ */ jsxDEV(card_exports.CardTitle, {
		className: "flex items-center gap-2",
		children: [/* @__PURE__ */ jsxDEV(CreditCard, { className: "h-5 w-5" }, void 0, false, {
			fileName: _jsxFileName$4,
			lineNumber: 149,
			columnNumber: 11
		}, this), "Stripe Integration"]
	}, void 0, true, {
		fileName: _jsxFileName$4,
		lineNumber: 148,
		columnNumber: 9
	}, this) }, void 0, false, {
		fileName: _jsxFileName$4,
		lineNumber: 147,
		columnNumber: 7
	}, this), /* @__PURE__ */ jsxDEV(card_exports.CardContent, { children: /* @__PURE__ */ jsxDEV("div", {
		className: "flex items-center justify-center py-8",
		children: /* @__PURE__ */ jsxDEV(Loader2, { className: "h-6 w-6 animate-spin" }, void 0, false, {
			fileName: _jsxFileName$4,
			lineNumber: 155,
			columnNumber: 11
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$4,
		lineNumber: 154,
		columnNumber: 9
	}, this) }, void 0, false, {
		fileName: _jsxFileName$4,
		lineNumber: 153,
		columnNumber: 7
	}, this)] }, void 0, true, {
		fileName: _jsxFileName$4,
		lineNumber: 146,
		columnNumber: 5
	}, this);
}
function StripeEmptyState({ connecting, onConnect }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: "text-center mx-auto h-full flex flex-col justify-center items-center py-8",
		children: [
			/* @__PURE__ */ jsxDEV(CreditCard, { className: "h-12 w-12 mx-auto text-muted-foreground mb-4" }, void 0, false, {
				fileName: _jsxFileName$4,
				lineNumber: 172,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV("h3", {
				className: "text-lg font-semibold mb-2",
				children: "No Stripe Account Connected"
			}, void 0, false, {
				fileName: _jsxFileName$4,
				lineNumber: 173,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV("p", {
				className: "text-muted-foreground mb-6",
				children: "Connect your Stripe account to start accepting payments"
			}, void 0, false, {
				fileName: _jsxFileName$4,
				lineNumber: 176,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV(Button, {
				onClick: onConnect,
				disabled: connecting,
				children: [connecting && /* @__PURE__ */ jsxDEV(Loader2, { className: "mr-2 h-4 w-4 animate-spin" }, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 180,
					columnNumber: 24
				}, this), "Connect Stripe Account"]
			}, void 0, true, {
				fileName: _jsxFileName$4,
				lineNumber: 179,
				columnNumber: 7
			}, this)
		]
	}, void 0, true, {
		fileName: _jsxFileName$4,
		lineNumber: 171,
		columnNumber: 5
	}, this);
}
function StripeAccountDetailsGrid({ dbFragment }) {
	const account = getFragmentData(StripeAccountDetailsFragment, dbFragment).stripeAccount;
	if (!account) return null;
	return /* @__PURE__ */ jsxDEV("div", {
		className: "grid grid-cols-1 md:grid-cols-2 gap-4",
		children: [
			/* @__PURE__ */ jsxDEV("div", {
				className: "space-y-2",
				children: [/* @__PURE__ */ jsxDEV("label", {
					className: "text-sm font-medium text-muted-foreground",
					children: "Business Name"
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 233,
					columnNumber: 9
				}, this), /* @__PURE__ */ jsxDEV("p", {
					className: "font-medium",
					children: account.businessProfile?.name || "Not provided"
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 236,
					columnNumber: 9
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$4,
				lineNumber: 232,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV("div", {
				className: "space-y-2",
				children: [/* @__PURE__ */ jsxDEV("label", {
					className: "text-sm font-medium text-muted-foreground",
					children: "Email"
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 241,
					columnNumber: 9
				}, this), /* @__PURE__ */ jsxDEV("p", {
					className: "font-medium",
					children: account.email
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 244,
					columnNumber: 9
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$4,
				lineNumber: 240,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV("div", {
				className: "space-y-2",
				children: [/* @__PURE__ */ jsxDEV("label", {
					className: "text-sm font-medium text-muted-foreground",
					children: "Country"
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 247,
					columnNumber: 9
				}, this), /* @__PURE__ */ jsxDEV("p", {
					className: "font-medium",
					children: account.country
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 250,
					columnNumber: 9
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$4,
				lineNumber: 246,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV("div", {
				className: "space-y-2",
				children: [/* @__PURE__ */ jsxDEV("label", {
					className: "text-sm font-medium text-muted-foreground",
					children: "Currency"
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 253,
					columnNumber: 9
				}, this), /* @__PURE__ */ jsxDEV("p", {
					className: "font-medium",
					children: account.defaultCurrency
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 256,
					columnNumber: 9
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$4,
				lineNumber: 252,
				columnNumber: 7
			}, this)
		]
	}, void 0, true, {
		fileName: _jsxFileName$4,
		lineNumber: 231,
		columnNumber: 5
	}, this);
}
function StripeCapabilities({ cardsEnabled, bankTransfersEnabled }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: "space-y-3",
		children: [/* @__PURE__ */ jsxDEV("h4", {
			className: "font-medium",
			children: "Account Capabilities"
		}, void 0, false, {
			fileName: _jsxFileName$4,
			lineNumber: 272,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV("div", {
			className: "grid grid-cols-1 md:grid-cols-2 gap-3",
			children: [/* @__PURE__ */ jsxDEV("div", {
				className: "flex items-center gap-2",
				children: [cardsEnabled ? /* @__PURE__ */ jsxDEV(CheckCircle, { className: "h-4 w-4 text-green-500" }, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 276,
					columnNumber: 13
				}, this) : /* @__PURE__ */ jsxDEV(AlertCircle, { className: "h-4 w-4 text-red-500" }, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 278,
					columnNumber: 13
				}, this), /* @__PURE__ */ jsxDEV("span", {
					className: "text-sm",
					children: "Accept Card Payments"
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 280,
					columnNumber: 11
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$4,
				lineNumber: 274,
				columnNumber: 9
			}, this), /* @__PURE__ */ jsxDEV("div", {
				className: "flex items-center gap-2",
				children: [bankTransfersEnabled ? /* @__PURE__ */ jsxDEV(CheckCircle, { className: "h-4 w-4 text-green-500" }, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 284,
					columnNumber: 13
				}, this) : /* @__PURE__ */ jsxDEV(AlertCircle, { className: "h-4 w-4 text-red-500" }, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 286,
					columnNumber: 13
				}, this), /* @__PURE__ */ jsxDEV("span", {
					className: "text-sm",
					children: "Receive Bank Transfers"
				}, void 0, false, {
					fileName: _jsxFileName$4,
					lineNumber: 288,
					columnNumber: 11
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$4,
				lineNumber: 282,
				columnNumber: 9
			}, this)]
		}, void 0, true, {
			fileName: _jsxFileName$4,
			lineNumber: 273,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$4,
		lineNumber: 271,
		columnNumber: 5
	}, this);
}
function StripeActions({ onManageAccount, onDisconnect, disconnecting }) {
	return /* @__PURE__ */ jsxDEV("div", {
		className: "flex flex-col sm:flex-row gap-3",
		children: [/* @__PURE__ */ jsxDEV(Button, {
			variant: "outline",
			onClick: onManageAccount,
			children: [/* @__PURE__ */ jsxDEV(Settings, { className: "mr-2 h-4 w-4" }, void 0, false, {
				fileName: _jsxFileName$4,
				lineNumber: 333,
				columnNumber: 9
			}, this), "Manage Account"]
		}, void 0, true, {
			fileName: _jsxFileName$4,
			lineNumber: 332,
			columnNumber: 7
		}, this), /* @__PURE__ */ jsxDEV(Button, {
			variant: "outline",
			onClick: onDisconnect,
			disabled: disconnecting,
			className: "text-destructive hover:text-destructive bg-transparent",
			children: [disconnecting ? /* @__PURE__ */ jsxDEV(Loader2, { className: "mr-2 h-4 w-4 animate-spin" }, void 0, false, {
				fileName: _jsxFileName$4,
				lineNumber: 343,
				columnNumber: 11
			}, this) : /* @__PURE__ */ jsxDEV(Unlink, { className: "mr-2 h-4 w-4" }, void 0, false, {
				fileName: _jsxFileName$4,
				lineNumber: 345,
				columnNumber: 11
			}, this), "Disconnect Account"]
		}, void 0, true, {
			fileName: _jsxFileName$4,
			lineNumber: 336,
			columnNumber: 7
		}, this)]
	}, void 0, true, {
		fileName: _jsxFileName$4,
		lineNumber: 331,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/theme-provider.tsx
var _jsxFileName$3 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/theme-provider.tsx";
var ThemeProviderContext = createContext({
	theme: "dark",
	setTheme: () => null
});
function ThemeProvider({ children, defaultTheme = "system", storageKey = "vite-ui-theme", ...props }) {
	const [theme, setTheme] = useState(() => localStorage.getItem(storageKey) || defaultTheme);
	useEffect(() => {
		const root = window.document.documentElement;
		root.classList.remove("light", "dark");
		if (theme === "system") {
			const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
			root.classList.add(systemTheme);
			return;
		}
		root.classList.add(theme);
	}, [theme]);
	const value = {
		theme,
		setTheme: (theme) => {
			localStorage.setItem(storageKey, theme);
			setTheme(theme);
		}
	};
	return /* @__PURE__ */ jsxDEV(ThemeProviderContext.Provider, {
		...props,
		value,
		children
	}, void 0, false, {
		fileName: _jsxFileName$3,
		lineNumber: 60,
		columnNumber: 5
	}, this);
}
var useTheme = () => {
	const context = useContext(ThemeProviderContext);
	if (context === void 0) throw new Error("useTheme must be used within a ThemeProvider");
	return context;
};
//#endregion
//#region src/design/organisms/prelaunch/early-access-dialog.tsx
var _jsxFileName$2 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/prelaunch/early-access-dialog.tsx";
var emptyEarlyAccessActionState = {
	message: "",
	status: "idle"
};
function EarlyAccessDialog({ action, ctaLabel = "Claim early access", defaultOpen = false, description = "Be among the first to experience Chip. We'll reach out with next steps.", finePrint = "No payment required. We'll notify you when your spot is confirmed.", successDescription = "Your request has been received. We'll follow up soon with next steps for early access.", successTitle = "Thank you.", title = "Get Early Access" }) {
	const [dialogKey, setDialogKey] = useState(0);
	const [isOpen, setIsOpen] = useState(defaultOpen);
	function handleOpenChange(nextOpen) {
		setIsOpen(nextOpen);
		if (nextOpen) return;
		startTransition(() => setDialogKey((current) => current + 1));
	}
	return /* @__PURE__ */ jsxDEV(Fragment, { children: [/* @__PURE__ */ jsxDEV(Button, {
		className: "prelaunch-cta-button",
		onClick: () => setIsOpen(true),
		type: "button",
		variant: "glass",
		children: ctaLabel
	}, void 0, false, {
		fileName: _jsxFileName$2,
		lineNumber: 60,
		columnNumber: 7
	}, this), /* @__PURE__ */ jsxDEV(Dialog, {
		onOpenChange: handleOpenChange,
		open: isOpen,
		children: /* @__PURE__ */ jsxDEV(DialogContent, {
			className: "max-h-[90vh] w-[calc(100%-1rem)] max-w-md gap-0 overflow-y-auto rounded-3xl border-border/60 bg-background/95 p-0 text-foreground shadow-2xl backdrop-blur",
			showCloseButton: false,
			children: /* @__PURE__ */ jsxDEV(EarlyAccessDialogBody, {
				action,
				description,
				finePrint,
				successDescription,
				successTitle,
				title
			}, dialogKey, false, {
				fileName: _jsxFileName$2,
				lineNumber: 74,
				columnNumber: 11
			}, this)
		}, void 0, false, {
			fileName: _jsxFileName$2,
			lineNumber: 70,
			columnNumber: 9
		}, this)
	}, void 0, false, {
		fileName: _jsxFileName$2,
		lineNumber: 69,
		columnNumber: 7
	}, this)] }, void 0, true);
}
function EarlyAccessDialogBody({ action, description, finePrint, successDescription, successTitle, title }) {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [state, setState] = useState(emptyEarlyAccessActionState);
	async function handleSubmit(event) {
		event.preventDefault();
		if (isSubmitting) return;
		const formData = new FormData(event.currentTarget);
		setIsSubmitting(true);
		setState(emptyEarlyAccessActionState);
		try {
			setState(await action(formData));
		} catch (error) {
			console.error("Early access submission failed", error);
			setState({
				message: "We couldn't submit your request right now. Please try again.",
				status: "error"
			});
		} finally {
			setIsSubmitting(false);
		}
	}
	return /* @__PURE__ */ jsxDEV("div", {
		className: "grid gap-4 p-4 sm:gap-5 sm:p-6",
		children: [/* @__PURE__ */ jsxDEV("div", {
			"aria-hidden": "true",
			className: "mx-auto h-1 w-10 rounded-full bg-white/20"
		}, void 0, false, {
			fileName: _jsxFileName$2,
			lineNumber: 128,
			columnNumber: 7
		}, this), state.status === "success" ? /* @__PURE__ */ jsxDEV("div", {
			"aria-live": "polite",
			className: "rounded-[28px] border border-emerald-400/20 bg-[linear-gradient(180deg,rgba(34,197,94,0.14)_0%,rgba(16,23,36,0.92)_45%,rgba(16,23,36,0.98)_100%)] px-6 py-8 text-center shadow-[0_24px_60px_rgba(0,0,0,0.22)]",
			role: "status",
			children: /* @__PURE__ */ jsxDEV("div", {
				className: "grid justify-items-center gap-4",
				children: [
					/* @__PURE__ */ jsxDEV("div", {
						className: "inline-flex items-center rounded-full border border-emerald-300/20 bg-emerald-400/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-emerald-200",
						children: "Early access request received"
					}, void 0, false, {
						fileName: _jsxFileName$2,
						lineNumber: 137,
						columnNumber: 13
					}, this),
					/* @__PURE__ */ jsxDEV("div", {
						className: "grid size-16 place-items-center rounded-full border border-emerald-300/20 bg-emerald-400/10 text-emerald-200 shadow-[0_0_0_8px_rgba(74,222,128,0.08)]",
						children: /* @__PURE__ */ jsxDEV(CheckIcon, {
							"aria-hidden": "true",
							className: "size-7"
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 141,
							columnNumber: 15
						}, this)
					}, void 0, false, {
						fileName: _jsxFileName$2,
						lineNumber: 140,
						columnNumber: 13
					}, this),
					/* @__PURE__ */ jsxDEV("div", {
						className: "space-y-2",
						children: [/* @__PURE__ */ jsxDEV("div", {
							className: "text-3xl font-bold tracking-tight",
							children: successTitle
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 144,
							columnNumber: 15
						}, this), /* @__PURE__ */ jsxDEV("p", {
							className: "mx-auto max-w-sm text-sm leading-relaxed text-muted-foreground",
							children: successDescription
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 147,
							columnNumber: 15
						}, this)]
					}, void 0, true, {
						fileName: _jsxFileName$2,
						lineNumber: 143,
						columnNumber: 13
					}, this),
					/* @__PURE__ */ jsxDEV("p", {
						className: "text-xs uppercase tracking-[0.18em] text-muted-foreground/90",
						children: "Keep an eye on your inbox."
					}, void 0, false, {
						fileName: _jsxFileName$2,
						lineNumber: 151,
						columnNumber: 13
					}, this)
				]
			}, void 0, true, {
				fileName: _jsxFileName$2,
				lineNumber: 136,
				columnNumber: 11
			}, this)
		}, void 0, false, {
			fileName: _jsxFileName$2,
			lineNumber: 131,
			columnNumber: 9
		}, this) : /* @__PURE__ */ jsxDEV(Fragment, { children: [
			/* @__PURE__ */ jsxDEV("div", {
				className: "grid gap-2 text-center",
				children: [/* @__PURE__ */ jsxDEV(DialogTitle, {
					className: "text-2xl font-bold tracking-tight",
					children: title
				}, void 0, false, {
					fileName: _jsxFileName$2,
					lineNumber: 159,
					columnNumber: 13
				}, this), /* @__PURE__ */ jsxDEV(DialogDescription, {
					className: "mx-auto max-w-sm text-sm leading-relaxed text-muted-foreground",
					children: description
				}, void 0, false, {
					fileName: _jsxFileName$2,
					lineNumber: 162,
					columnNumber: 13
				}, this)]
			}, void 0, true, {
				fileName: _jsxFileName$2,
				lineNumber: 158,
				columnNumber: 11
			}, this),
			/* @__PURE__ */ jsxDEV("form", {
				className: "grid gap-4",
				onSubmit: handleSubmit,
				children: [
					/* @__PURE__ */ jsxDEV("div", {
						className: "grid gap-2",
						children: [/* @__PURE__ */ jsxDEV(Label, {
							className: "text-xs font-semibold uppercase tracking-wide text-muted-foreground",
							htmlFor: "early-access-name",
							children: "Full Name"
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 169,
							columnNumber: 15
						}, this), /* @__PURE__ */ jsxDEV(Input, {
							autoComplete: "name",
							className: "h-12 rounded-2xl border-border/60 bg-background/40 px-4 text-base md:text-base",
							id: "early-access-name",
							name: "name",
							placeholder: "Jane Doe",
							required: true,
							type: "text"
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 175,
							columnNumber: 15
						}, this)]
					}, void 0, true, {
						fileName: _jsxFileName$2,
						lineNumber: 168,
						columnNumber: 13
					}, this),
					/* @__PURE__ */ jsxDEV("div", {
						className: "grid gap-2",
						children: [/* @__PURE__ */ jsxDEV(Label, {
							className: "text-xs font-semibold uppercase tracking-wide text-muted-foreground",
							htmlFor: "early-access-email",
							children: "Email"
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 187,
							columnNumber: 15
						}, this), /* @__PURE__ */ jsxDEV(Input, {
							autoComplete: "email",
							className: "h-12 rounded-2xl border-border/60 bg-background/40 px-4 text-base md:text-base",
							id: "early-access-email",
							name: "email",
							placeholder: "jane@example.com",
							required: true,
							type: "email"
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 193,
							columnNumber: 15
						}, this)]
					}, void 0, true, {
						fileName: _jsxFileName$2,
						lineNumber: 186,
						columnNumber: 13
					}, this),
					/* @__PURE__ */ jsxDEV("div", {
						className: "grid gap-2",
						children: [/* @__PURE__ */ jsxDEV(Label, {
							className: "text-xs font-semibold uppercase tracking-wide text-muted-foreground",
							htmlFor: "early-access-phone",
							children: "Phone"
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 205,
							columnNumber: 15
						}, this), /* @__PURE__ */ jsxDEV(Input, {
							autoComplete: "tel",
							className: "h-12 rounded-2xl border-border/60 bg-background/40 px-4 text-base md:text-base",
							id: "early-access-phone",
							name: "phone",
							placeholder: "+1 (555) 123-4567",
							type: "tel"
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 211,
							columnNumber: 15
						}, this)]
					}, void 0, true, {
						fileName: _jsxFileName$2,
						lineNumber: 204,
						columnNumber: 13
					}, this),
					/* @__PURE__ */ jsxDEV("div", {
						className: "grid gap-2",
						children: [/* @__PURE__ */ jsxDEV(Label, {
							className: "text-xs font-semibold uppercase tracking-wide text-muted-foreground",
							htmlFor: "early-access-zip",
							children: "Zip Code"
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 222,
							columnNumber: 15
						}, this), /* @__PURE__ */ jsxDEV(Input, {
							autoComplete: "postal-code",
							className: "h-12 rounded-2xl border-border/60 bg-background/40 px-4 text-base md:text-base",
							id: "early-access-zip",
							inputMode: "numeric",
							name: "zip",
							placeholder: "90291",
							type: "text"
						}, void 0, false, {
							fileName: _jsxFileName$2,
							lineNumber: 228,
							columnNumber: 15
						}, this)]
					}, void 0, true, {
						fileName: _jsxFileName$2,
						lineNumber: 221,
						columnNumber: 13
					}, this),
					/* @__PURE__ */ jsxDEV(SubmitButton, { pending: isSubmitting }, void 0, false, {
						fileName: _jsxFileName$2,
						lineNumber: 239,
						columnNumber: 13
					}, this),
					/* @__PURE__ */ jsxDEV(FormFeedback, {
						errorMessage: state.status === "error" ? state.message : "",
						pending: isSubmitting
					}, void 0, false, {
						fileName: _jsxFileName$2,
						lineNumber: 240,
						columnNumber: 13
					}, this)
				]
			}, void 0, true, {
				fileName: _jsxFileName$2,
				lineNumber: 167,
				columnNumber: 11
			}, this),
			/* @__PURE__ */ jsxDEV("p", {
				className: "text-center text-xs leading-6 text-muted-foreground",
				children: finePrint
			}, void 0, false, {
				fileName: _jsxFileName$2,
				lineNumber: 246,
				columnNumber: 11
			}, this)
		] }, void 0, true)]
	}, void 0, true, {
		fileName: _jsxFileName$2,
		lineNumber: 127,
		columnNumber: 5
	}, this);
}
function SubmitButton({ pending }) {
	return /* @__PURE__ */ jsxDEV(Button, {
		className: "mt-1 h-12 w-full rounded-2xl text-base font-semibold",
		disabled: pending,
		type: "submit",
		variant: "glass",
		children: pending ? "Submitting..." : "Request Access"
	}, void 0, false, {
		fileName: _jsxFileName$2,
		lineNumber: 257,
		columnNumber: 5
	}, this);
}
function FormFeedback({ errorMessage, pending }) {
	if (pending) return /* @__PURE__ */ jsxDEV("p", {
		"aria-live": "polite",
		className: "rounded-2xl bg-white/5 px-4 py-4 text-center text-sm text-muted-foreground",
		children: "Sending your request..."
	}, void 0, false, {
		fileName: _jsxFileName$2,
		lineNumber: 277,
		columnNumber: 7
	}, this);
	if (!errorMessage) return null;
	return /* @__PURE__ */ jsxDEV("p", {
		"aria-live": "polite",
		className: "rounded-2xl border border-red-400/20 bg-red-500/10 px-4 py-4 text-center text-sm text-red-200",
		children: errorMessage
	}, void 0, false, {
		fileName: _jsxFileName$2,
		lineNumber: 288,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/design/organisms/prelaunch/password-gate-overlay.tsx
var _jsxFileName$1 = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/design/organisms/prelaunch/password-gate-overlay.tsx";
var DISMISS_DURATION_MS = 1600;
var SHAKE_DURATION_MS = 500;
function PasswordGateOverlay({ correctPassword, errorMessage = "Incorrect password.", headline = "Welcome", placeholder = "Password", submitLabel = "Enter" }) {
	const inputId = useId();
	const [isDismissed, setIsDismissed] = useState(false);
	const [isRemoved, setIsRemoved] = useState(false);
	const [isShaking, setIsShaking] = useState(false);
	const [password, setPassword] = useState("");
	const [showError, setShowError] = useState(false);
	useEffect(() => {
		document.body.style.overflow = isDismissed ? "" : "hidden";
		return () => {
			document.body.style.overflow = "";
		};
	}, [isDismissed]);
	useEffect(() => {
		if (!isDismissed) return;
		const timer = window.setTimeout(() => setIsRemoved(true), DISMISS_DURATION_MS);
		return () => window.clearTimeout(timer);
	}, [isDismissed]);
	function handleSubmit(event) {
		event.preventDefault();
		if (password === correctPassword) {
			setShowError(false);
			startTransition(() => setIsDismissed(true));
			return;
		}
		setShowError(true);
		setPassword("");
		setIsShaking(false);
		requestAnimationFrame(() => {
			setIsShaking(true);
			const input = document.getElementById(inputId);
			if (input instanceof HTMLInputElement) input.focus();
		});
		window.setTimeout(() => setIsShaking(false), SHAKE_DURATION_MS);
	}
	if (isRemoved) return null;
	return /* @__PURE__ */ jsxDEV("div", {
		"aria-labelledby": `${inputId}-headline`,
		"aria-modal": "true",
		className: clsx$1("prelaunch-gate", isDismissed && "is-dismissed"),
		role: "dialog",
		children: [
			/* @__PURE__ */ jsxDEV("div", { className: "prelaunch-gate-backdrop" }, void 0, false, {
				fileName: _jsxFileName$1,
				lineNumber: 85,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV("div", { className: "prelaunch-gate-scrim" }, void 0, false, {
				fileName: _jsxFileName$1,
				lineNumber: 86,
				columnNumber: 7
			}, this),
			/* @__PURE__ */ jsxDEV("div", {
				className: clsx$1("prelaunch-gate-panel", isShaking && "is-shaking"),
				children: [
					/* @__PURE__ */ jsxDEV("h1", {
						className: "prelaunch-gate-headline",
						id: `${inputId}-headline`,
						children: headline
					}, void 0, false, {
						fileName: _jsxFileName$1,
						lineNumber: 89,
						columnNumber: 9
					}, this),
					/* @__PURE__ */ jsxDEV("form", {
						className: "prelaunch-gate-form",
						onSubmit: handleSubmit,
						children: [
							/* @__PURE__ */ jsxDEV("label", {
								className: "sr-only",
								htmlFor: inputId,
								children: placeholder
							}, void 0, false, {
								fileName: _jsxFileName$1,
								lineNumber: 94,
								columnNumber: 11
							}, this),
							/* @__PURE__ */ jsxDEV(Input, {
								autoComplete: "off",
								autoFocus: true,
								className: "prelaunch-gate-input",
								id: inputId,
								onChange: (event) => setPassword(event.currentTarget.value),
								placeholder,
								spellCheck: false,
								type: "password",
								value: password
							}, void 0, false, {
								fileName: _jsxFileName$1,
								lineNumber: 97,
								columnNumber: 11
							}, this),
							/* @__PURE__ */ jsxDEV(Button$1, {
								"aria-label": submitLabel,
								className: "prelaunch-gate-submit",
								type: "submit",
								variant: "glass",
								children: /* @__PURE__ */ jsxDEV(ArrowRightIcon, { "aria-hidden": "true" }, void 0, false, {
									fileName: _jsxFileName$1,
									lineNumber: 115,
									columnNumber: 13
								}, this)
							}, void 0, false, {
								fileName: _jsxFileName$1,
								lineNumber: 109,
								columnNumber: 11
							}, this)
						]
					}, void 0, true, {
						fileName: _jsxFileName$1,
						lineNumber: 93,
						columnNumber: 9
					}, this),
					/* @__PURE__ */ jsxDEV("p", {
						"aria-live": "polite",
						className: clsx$1("prelaunch-gate-error", showError && "is-visible"),
						children: errorMessage
					}, void 0, false, {
						fileName: _jsxFileName$1,
						lineNumber: 119,
						columnNumber: 9
					}, this)
				]
			}, void 0, true, {
				fileName: _jsxFileName$1,
				lineNumber: 88,
				columnNumber: 7
			}, this)
		]
	}, void 0, true, {
		fileName: _jsxFileName$1,
		lineNumber: 79,
		columnNumber: 5
	}, this);
}
//#endregion
//#region src/lib/organization/organization-provider.tsx
var _jsxFileName = "/home/runner/work/chip-monorepo/chip-monorepo/packages/lib-web-ui-common/src/lib/organization/organization-provider.tsx";
var MyOrganizationsFragment = graphql(`
  fragment MyOrganizationsFragment on Profiles {
    id
    organizationMembersCollection {
      edges {
        node {
          id
          organization {
            id
            name
          }
        }
      }
    }
  }
`);
var ORG_LOCAL_STORAGE_KEY = "qq-current-organization-id";
var OrganizationContext = React.createContext({
	currentOrganization: null,
	allOrganizations: [],
	loading: false,
	missingOrganization: null,
	setOrganizationId: null
});
function useOrganization() {
	const org = React.useContext(OrganizationContext);
	if (!org) throw new Error("OrganizationProvider not found");
	return org;
}
function OrganizationProvider({ children, dbFragment, loading }) {
	const [currentOrgId, setCurrentOrgIdInner] = React.useState(null);
	const orgs = React.useMemo(() => !dbFragment ? [] : filterNulls(getFragmentData(MyOrganizationsFragment, dbFragment).organizationMembersCollection?.edges?.map((edge) => edge.node.organization)) ?? [], [dbFragment]);
	React.useEffect(() => {
		const stored = localStorage.getItem(ORG_LOCAL_STORAGE_KEY);
		if (stored) setCurrentOrgIdInner(stored);
		localStorage.removeItem(ORG_LOCAL_STORAGE_KEY);
	}, [orgs]);
	const currentOrganization = React.useMemo(() => orgs?.find?.((org) => org.id === currentOrgId) ?? null, [currentOrgId, orgs]);
	const setCurrentOrgId = (id) => {
		localStorage.setItem(ORG_LOCAL_STORAGE_KEY, id);
		setCurrentOrgIdInner(id);
	};
	React.useEffect(() => {
		if (orgs.length > 0 && !currentOrgId) setCurrentOrgId(orgs[0].id);
	}, [orgs, currentOrgId]);
	return /* @__PURE__ */ jsxDEV(OrganizationContext.Provider, {
		value: {
			setOrganizationId: setCurrentOrgId,
			currentOrganization,
			missingOrganization: loading ? null : orgs.length === 0,
			allOrganizations: loading ? null : orgs,
			loading
		},
		children
	}, void 0, false, {
		fileName: _jsxFileName,
		lineNumber: 91,
		columnNumber: 5
	}, this);
}
__reExport(/* @__PURE__ */ __exportAll({
	AppSidebar: () => AppSidebar,
	Button: () => Button,
	Caption: () => Caption,
	CardContainer: () => CardContainer,
	Container: () => Container,
	CreateNewOrganizationForm: () => CreateNewOrganizationForm,
	CrossfadeImageStack: () => CrossfadeImageStack,
	EarlyAccessDialog: () => EarlyAccessDialog,
	EmailTable: () => EmailTable,
	FloatingPanel: () => FloatingPanel,
	FloatingToolbar: () => FloatingToolbar,
	FullPageCard: () => FullPageCard,
	GoogleSignIn: () => GoogleSignIn,
	H1: () => H1,
	H2: () => H2,
	H3: () => H3,
	H4: () => H4,
	H5: () => H5,
	H6: () => H6,
	IconDock: () => IconDock,
	InputOtp: () => InputOtp,
	InputWithButton: () => InputWithButton,
	JsonDisplay: () => JsonDisplay,
	MapRouteLegend: () => MapRouteLegend,
	MapSurface: () => MapSurface,
	MyOrganizationsFragment: () => MyOrganizationsFragment,
	MyPendingInviteList: () => MyPendingInviteList,
	MyPendingInviteListFragment: () => MyPendingInviteListFragment,
	OrganizationPage: () => OrganizationPage,
	OrganizationPageFragment: () => OrganizationPageFragment,
	OrganizationProvider: () => OrganizationProvider,
	OtpEntryPage: () => OtpEntryPage,
	P: () => P,
	PageHeader: () => PageHeader,
	PasswordGateOverlay: () => PasswordGateOverlay,
	PillButtonGroup: () => PillButtonGroup,
	PrelaunchHeroScene: () => PrelaunchHeroScene,
	PricingCard: () => PricingCard,
	PricingCardFragment: () => PricingCardFragment,
	PricingTable: () => PricingTable,
	PricingTableFragment: () => PricingTableFragment,
	SearchCombobox: () => SearchCombobox,
	SidebarLayout: () => SidebarLayout,
	SidebarProvider: () => SidebarProvider,
	SignInPage: () => SignInPage,
	Spinner: () => Spinner,
	SpinnerButton: () => SpinnerButton,
	StripeAccountFragment: () => StripeAccountFragment,
	StripeEmptyState: () => StripeEmptyState,
	StripeLoadingCard: () => StripeLoadingCard,
	StripeSettings: () => StripeSettings,
	ThemeProvider: () => ThemeProvider,
	Toaster: () => Toaster,
	buttonVariants: () => buttonVariants,
	emptyEarlyAccessActionState: () => emptyEarlyAccessActionState,
	fmtDt: () => fmtDt,
	toast: () => toast,
	useOrganization: () => useOrganization,
	useTheme: () => useTheme
}), card_exports);
//#endregion
export { AppSidebar, Button, Caption, CardContainer, Container, CreateNewOrganizationForm, CrossfadeImageStack, EarlyAccessDialog, EmailTable, FloatingPanel, FloatingToolbar, FullPageCard, GoogleSignIn, H1, H2, H3, H4, H5, H6, IconDock, InputOtp, InputWithButton, JsonDisplay, MapRouteLegend, MapSurface, MyOrganizationsFragment, MyPendingInviteList, MyPendingInviteListFragment, OrganizationPage, OrganizationPageFragment, OrganizationProvider, OtpEntryPage, P, PageHeader, PasswordGateOverlay, PillButtonGroup, PrelaunchHeroScene, PricingCard, PricingCardFragment, PricingTable, PricingTableFragment, SearchCombobox, SidebarLayout, SidebarProvider, SignInPage, Spinner, SpinnerButton, StripeAccountFragment, StripeEmptyState, StripeLoadingCard, StripeSettings, ThemeProvider, Toaster, buttonVariants, emptyEarlyAccessActionState, fmtDt, toast, useOrganization, useTheme };

//# sourceMappingURL=index.js.map